var TurnTo =
TurnToWpJsonp([11],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_browser_utils__ = __webpack_require__(16);

function closest(el, selector) {
    var matches = Element.prototype.matches ? el.matches(selector) : el.msMatchesSelector(selector);
    if (!matches && el.parentNode.nodeName === 'BODY') {
        return null;
    }
    return matches ? el : closest(el.parentNode, selector);
}
function elementIsVisible(elem) {
    return elem && elem.offsetWidth > 0 && elem.offsetHeight > 0;
}
function getLikelyTabbableElems(parent) {
    return parent.querySelectorAll('[tabindex],a,input,select,textarea,button,object');
}
// The checkboxes and radio buttons are hidden, so not really visible, even though there
// is a radio/checkbox styled element on the screen.  So, need to do a special check
// for them.  Going to assume they are tabbable if the parent is visible
function isTabbableCheckboxOrRadio(elem) {
    var nodeName = elem.nodeName.toLowerCase();
    return nodeName === 'input' && (elem.type === 'radio' || elem.type === 'checkbox') &&
        elementIsVisible(elem.parentNode);
}
function elemHasTabIndex(elem) {
    // The checkboxes and radio buttons are hidden, so not really visible, even though there
    // is a radio/checkbox styled element on the screen.  So, need to do a special check
    // for them
    if (elementIsVisible(elem) || isTabbableCheckboxOrRadio(elem)) {
        var tabIndex = elem.getAttribute('tabindex');
        var nodeName = elem.nodeName.toLowerCase();
        var hasTabindex = tabIndex !== null && tabIndex >= 0;
        if (/^(input|select|textarea|button|object)$/.test(nodeName)) {
            hasTabindex = !elem.disabled;
            // NOTE: Not checking for disabled fieldsets. Add later if needed. The following comment
            // is from jQuery:
            // Form controls within a disabled fieldset are disabled.
            // However, controls within the fieldset's legend do not get disabled.
            // Since controls generally aren't placed inside legends, we skip
            // this portion of the check.
        }
        else if (nodeName === 'a') {
            hasTabindex = elem.href || hasTabindex;
        }
        return hasTabindex;
    }
    return false;
}
function scrollToElement(el) {
    if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
}
function whenElementIsVisible(elOrFunc, maxAttempts, attempt) {
    if (maxAttempts === void 0) { maxAttempts = 10; }
    if (attempt === void 0) { attempt = 1; }
    return new Promise(function (resolve, reject) {
        // elOrFunc is an element or a function.  If a function, it is called to get the el. This is
        // to handle cases where the method of retrieving the el must continue to be called.  The
        // most obvious case is a $refs reference that is not yet rendered
        var el = typeof elOrFunc === 'function' ? elOrFunc() : elOrFunc;
        if (elementIsVisible(el)) {
            resolve(el);
        }
        else if (attempt < maxAttempts) {
            window.requestAnimationFrame(function () {
                whenElementIsVisible(elOrFunc, maxAttempts, attempt + 1)
                    .then(function (visibleEl) { return resolve(visibleEl); }).catch(function () { return reject(); });
            });
        }
        else {
            reject();
        }
    });
}
function getRefEl(refs, refName) {
    var ref = refs[refName];
    if (!ref) {
        return null;
    }
    return ref.tagName ? ref : ref.$el;
}
function whenRefIsVisible(refs, refName, maxAttempts) {
    if (maxAttempts === void 0) { maxAttempts = 10; }
    return whenElementIsVisible(function () { return getRefEl(refs, refName); }, maxAttempts);
}
var domReadyPromise = null;
/* harmony default export */ __webpack_exports__["a"] = ({
    /**
     * Same functionality as jQuery.closest where the element is passed in instead of called on
     * and it returns null if closest not found.
     * @param el - element to find closest for
     * @param selector - selector being searched for to be closest
     */
    closest: closest,
    /**
     * Determines whether the given element is visible or not
     * @param - the element
     */
    elementIsVisible: elementIsVisible,
    /**
     * Returns an array of elements within the given parent element that are tabbable.
     * Basics of implementation are from jQuery.
     */
    getTabbableElements: function (parent) {
        var likelyTabbableNodeList = getLikelyTabbableElems(parent);
        var tabbableElements = [];
        for (var i = 0; i < likelyTabbableNodeList.length; i++) {
            var elem = likelyTabbableNodeList[i];
            // The checkboxes and radio buttons are hidden, so not really visible, even though there
            // is a radio/checkbox styled element on the screen.  So, need to do a special check
            // for them
            if (elemHasTabIndex(elem)) {
                tabbableElements.push(elem);
            }
        }
        return tabbableElements;
    },
    /**
     * Creates a div with the given id and appends to the body if it doesn't already exist
     * @param id
     */
    appendDivToBody: function (id) {
        if (!document.getElementById(id)) {
            var container = document.createElement('div');
            container.id = id;
            document.body.appendChild(container);
        }
    },
    /**
     * Removes child element of body with the given id
     * @param id
     */
    removeFromBody: function (id) {
        var container = document.getElementById(id);
        if (container) {
            document.body.removeChild(container);
        }
    },
    onDomReady: function () {
        if (domReadyPromise) {
            return domReadyPromise;
        }
        domReadyPromise = new Promise(function (resolve) {
            if (document.readyState === 'complete' ||
                (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
                resolve();
            }
            else {
                document.addEventListener('DOMContentLoaded', resolve());
            }
        });
        return domReadyPromise;
    },
    /**
     * Foucs on the given element when it is visible
     * @param el
     * @param maxAttempts (optional with default of 10) - max attempts at checking
     */
    safeFocus: function (elOrFunc, maxAttempts) {
        if (maxAttempts === void 0) { maxAttempts = 10; }
        return whenElementIsVisible(elOrFunc, maxAttempts).then(function (visibleEl) {
            visibleEl.focus();
        });
    },
    /**
     * Foucs on the given element when it is visible
     * @param refs - this would be this.$refs inside a Vue component
     * @param refName - the name of the ref, called like this.$refs[refName]
     * @param maxAttempts (optional with default of 10) - max attempts at checking
     */
    safeFocusRef: function (refs, refName, maxAttempts) {
        if (maxAttempts === void 0) { maxAttempts = 10; }
        return whenRefIsVisible(refs, refName, maxAttempts).then(function (visibleEl) {
            visibleEl.focus();
        });
    },
    scrollToElement: scrollToElement,
    scrollToRef: function (refs, refName) {
        var el = getRefEl(refs, refName);
        if (el) {
            scrollToElement(el);
        }
    },
    /**
     * Same as scrollToRef, but will not scroll down, only up
     * @param refs
     * @param refName
     */
    scrollUpToRef: function (refs, refName, additionalPx) {
        if (additionalPx === void 0) { additionalPx = 0; }
        var el = getRefEl(refs, refName);
        if (el) {
            var viewportOffset = el.getBoundingClientRect();
            // these are relative to the viewport, i.e. the window
            var top_1 = viewportOffset.top;
            if (top_1 <= 0) {
                // top is negative, so like subtracting from how far page is currently scrolled
                var scrollToY = Math.floor(window.pageYOffset + top_1 - (additionalPx || 0));
                if (__WEBPACK_IMPORTED_MODULE_0_util_browser_utils__["g" /* isIE */] || __WEBPACK_IMPORTED_MODULE_0_util_browser_utils__["f" /* isEdge */]) {
                    window.scrollTo(window.pageXOffset, scrollToY);
                }
                else {
                    window.scrollTo({ top: scrollToY, behavior: 'smooth' });
                }
            }
        }
    },
    /**
     * Can be used to set the cursor at the end of text in a text field or textarea as well
     * as a contenteditable div
     * @param el - the element
     */
    setCursorAtEndOfText: function (el) {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    },
    /**
     * Returns a promise to resolve when the element becomes visible for the given number of
     * attempts.  An attempt is the time it takes for window.requestAnimationFrame() to be called.
     * It will be rejected if it is not visible after the given number of attempts.
     *
     * @param el - element to check for
     * @param maxAttempts (optional with default of 10) - max attempts at checking
     */
    whenElementIsVisible: whenElementIsVisible,
    /**
     * Returns a promise to resolve when the element the ref refers to becomes visible for the given
     * number of attempts.  An attempt is the time it takes for window.requestAnimationFrame() to be
     * called. It will be rejected if it is not visible after the given number of attempts.
     *
     * @param refs - this would be this.$refs inside a Vue component
     * @param refName - the name of the ref, called like this.$refs[refName]
     * @param maxAttempts (optional with default of 10) - max attempts at checking
     */
    whenRefIsVisible: whenRefIsVisible
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GlobalConfig */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultConfig; });
var GlobalConfig = /** @class */ (function () {
    function GlobalConfig(config) {
        this.additionalPagingScroll = config.additionalPagingScroll;
        this.authSettings = config.authSettings;
        this.mediaEnabled = config.mediaEnabled;
        this.multiItemAnswerEnabled = config.multiItemAnswerEnabled;
        this.multiItemPickerTitleLength = config.multiItemPickerTitleLength;
        this.siteName = config.siteName;
        this.ssoEnabled = config.ssoEnabled;
    }
    GlobalConfig.prototype.isAllowAnon = function () {
        return this.authSettings.question === 1;
    };
    GlobalConfig.prototype.isConfirmReq = function (ugcType) {
        if (ugcType === 'question' && this.authSettings.question === 3) {
            return true;
        }
        else if (['answer', 'reply'].indexOf(ugcType) > -1 && this.authSettings.answerReply === 2) {
            return true;
        }
        else if (ugcType === 'review' && this.authSettings.review === 3) {
            return true;
        }
        return false;
    };
    GlobalConfig.prototype.isPurchaseReq = function () {
        return this.authSettings.review === 4;
    };
    return GlobalConfig;
}());

var defaultConfig;
function loadConfig(config) {
    defaultConfig = new GlobalConfig(config);
}



/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Source; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_msg__ = __webpack_require__(4);




var Source;
(function (Source) {
    Source[Source["RSE"] = 0] = "RSE";
    Source[Source["DO_MORE"] = 1] = "DO_MORE";
    Source[Source["INLINE"] = 2] = "INLINE";
})(Source || (Source = {}));
var DEFAULT_STATE = JSON.stringify({
    addedMedia: [],
    catItem: null,
    currentPage: null,
    isLaunchingWriteReview: false,
    launchData: {},
    launchingElem: undefined,
    qaLaunchData: {},
    pageHistory: [],
    prevLaunchToken: null,
    isOpen: false,
    sellerRatingLaunchData: {},
    sku: '',
    siteKey: __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey
});
var SubmissionStore = /** @class */ (function () {
    function SubmissionStore() {
        this.state = JSON.parse(DEFAULT_STATE);
        this.eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
    }
    SubmissionStore.prototype.addMedia = function (media) {
        var _this = this;
        media.forEach(function (item) { return _this.state.addedMedia.push(item); });
    };
    SubmissionStore.prototype.close = function () {
        if (this.state.launchingElem) {
            this.state.launchingElem.focus();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].safeFocus(document);
        }
        this.state.isOpen = false;
    };
    // returns the index of the item removed
    SubmissionStore.prototype.removeMedia = function (mediaItem) {
        for (var i = 0; i < this.state.addedMedia.length; i++) {
            var thisItem = this.state.addedMedia[i];
            if (mediaItem.id === thisItem.id) {
                this.state.addedMedia.splice(i, 1);
                return i;
            }
        }
        return -1;
    };
    Object.defineProperty(SubmissionStore.prototype, "addedMedia", {
        get: function () {
            return this.state.addedMedia;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "catItem", {
        get: function () {
            return this.state.catItem;
        },
        set: function (catItem) {
            this.state.catItem = catItem;
            this.state.sku = catItem.sku;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "currentPage", {
        get: function () {
            return this.state.currentPage;
        },
        set: function (page) {
            // put previous page into history if there was one.  Not adding 'add-video' since it is not
            // a page the user can go back to.  Should be going back to the one before that.
            if (this.state.currentPage && this.state.currentPage.page !== 'add-video') {
                var newLength = this.state.pageHistory.unshift(this.state.currentPage);
                // only keep history up to previous 3 pages.  Shouldn't need but 2 or 3
                if (newLength > 3) {
                    this.state.pageHistory.splice(3);
                }
            }
            // Remove any 'back' listener from the eventBus to make sure they are cleaned up before going
            // to the next page
            this.eventBus.$off('back');
            this.state.currentPage = page;
        },
        enumerable: true,
        configurable: true
    });
    // a way for the submission modal to communicate to the screen widget that a "close" event has
    // taken place, which may mean "go back" to the previous modal screen.  The inidividual widget
    // can determine where to go back to or fire a close event back up to the submission modal.
    SubmissionStore.prototype.fireBackEvent = function () {
        // this is using the internal Vue api, which could change, but not likely -
        // https://forum.vuejs.org/t/detect-whether-there-are-event-listeners/10754
        // using to detect if the 'back' event is registered, if not, we can just close
        var events = this.eventBus._events;
        if (events && events.back) {
            this.eventBus.$emit('back');
            return;
        }
        this.close();
    };
    SubmissionStore.prototype.getLaunchToken = function () {
        return this.state.launchData.rseToken || this.state.qaLaunchData.emailToken ||
            this.state.sellerRatingLaunchData.emailToken || this.state.launchData.ssoToken ||
            this.state.prevLaunchToken;
    };
    Object.defineProperty(SubmissionStore.prototype, "isLaunchingWriteReview", {
        get: function () {
            return this.state.isLaunchingWriteReview;
        },
        set: function (isLaunching) {
            this.state.isLaunchingWriteReview = isLaunching;
        },
        enumerable: true,
        configurable: true
    });
    SubmissionStore.prototype.isVisualFirstFlow = function () {
        return this.state.launchData.startAction === 'visual';
    };
    Object.defineProperty(SubmissionStore.prototype, "launchData", {
        get: function () {
            return this.state.launchData;
        },
        set: function (launchData) {
            this.state.launchData = launchData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "qaLaunchData", {
        get: function () {
            return this.state.qaLaunchData;
        },
        set: function (launchData) {
            this.state.qaLaunchData = launchData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "sellerRatingLaunchData", {
        get: function () {
            return this.state.sellerRatingLaunchData;
        },
        set: function (launchData) {
            this.state.sellerRatingLaunchData = launchData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "isOpen", {
        get: function () {
            return this.state.isOpen;
        },
        set: function (isOpen) {
            this.state.isOpen = isOpen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "pageHistory", {
        get: function () {
            return this.state.pageHistory;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "poweredByText", {
        get: function () {
            var page = this.state.currentPage ? this.state.currentPage.page : null;
            if (page === 'do-more') {
                return Object(__WEBPACK_IMPORTED_MODULE_3_services_msg__["a" /* default */])('doMore.poweredBy');
            }
            else if (page === 'review-form' && !this.isVisualFirstFlow()) {
                return Object(__WEBPACK_IMPORTED_MODULE_3_services_msg__["a" /* default */])('submission.reviewsPoweredBy');
            }
            return Object(__WEBPACK_IMPORTED_MODULE_3_services_msg__["a" /* default */])('submission.visualPoweredBy');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "previousPage", {
        get: function () {
            return this.state.pageHistory.length > 0 ? this.state.pageHistory[0] : null;
        },
        enumerable: true,
        configurable: true
    });
    // This sets to all default values including isOpen false which will close the submission modal.
    // So only use when not staying in the modal
    SubmissionStore.prototype.resetStore = function () {
        this.state = JSON.parse(DEFAULT_STATE);
        // make sure all registered events ($on) are removed from the eventBus
        this.eventBus.$off();
    };
    // Resets to default values except:
    // - isOpen true so the modal does not close
    // - the catItem and siteKey
    // - launchingElem if present
    // - currentPage and pageHistory if present
    SubmissionStore.prototype.resetStoreWithCatItem = function (siteKey, catItem) {
        var prevLaunchToken = this.getLaunchToken();
        var launchingElem = this.state.launchingElem;
        var history = this.state.pageHistory;
        var currentPage = this.state.currentPage;
        var defaultState = JSON.parse(DEFAULT_STATE);
        defaultState.isOpen = true;
        defaultState.siteKey = siteKey;
        defaultState.launchingElem = launchingElem;
        defaultState.currentPage = currentPage;
        defaultState.pageHistory = history;
        defaultState.prevLaunchToken = prevLaunchToken;
        this.state = defaultState;
        this.catItem = catItem;
    };
    Object.defineProperty(SubmissionStore.prototype, "sku", {
        // setting sku is done through one of the startFlow functions
        get: function () {
            return this.state.sku;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "siblingSiteKey", {
        get: function () {
            return this.state.siteKey !== __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey ? this.state.siteKey : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "siteKey", {
        // setting siteKey is done through one of the startFlow functions
        get: function () {
            return this.state.siteKey;
        },
        enumerable: true,
        configurable: true
    });
    // start a flow with Do More or for use by other start flow functions
    SubmissionStore.prototype.startFlow = function (sku, siteKey, page) {
        this.state.sku = sku;
        this.state.siteKey = siteKey;
        this.currentPage = page;
    };
    // start a flow with QA Solo View
    SubmissionStore.prototype.startQaFlow = function (sku, siteKey, page, launchData) {
        this.state.qaLaunchData = launchData;
        this.startFlow(sku, siteKey, page);
    };
    // start a flow with review form or vc share
    SubmissionStore.prototype.startRevFlow = function (sku, siteKey, page, launchData, launchingElem) {
        if (launchingElem === void 0) { launchingElem = undefined; }
        this.state.launchData = launchData;
        // don't want body to be the launching element
        if (launchingElem && launchingElem.tagName.toLowerCase() !== 'body') {
            this.state.launchingElem = launchingElem;
        }
        this.startFlow(sku, siteKey, page);
    };
    SubmissionStore.prototype.startSellerRatingFlow = function (siteKey, page, launchData) {
        this.state.sellerRatingLaunchData = launchData;
        this.startFlow(null, siteKey, page);
    };
    // start a flow with Do More using catItem instead of sku
    SubmissionStore.prototype.startFlowWithCatItem = function (catItem, siteKey, page) {
        this.state.catItem = catItem;
        this.startFlow(catItem.sku, siteKey, page);
    };
    return SubmissionStore;
}());
/* harmony default export */ __webpack_exports__["b"] = (new SubmissionStore());


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* unused harmony export ApiService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_client__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_config__ = __webpack_require__(3);
/* tslint:disable */


function createRestError(xhr) {
    /* beautify ignore:start */
    var restError = {
        status: xhr.status,
        fieldErrors: []
    };
    /* beautify ignore:end */
    var errorsStr = xhr.getResponseHeader('turnto-error-msg');
    if (xhr.getResponseHeader('turnto-error') && errorsStr) {
        try {
            JSON.parse(errorsStr).forEach(function (error) {
                if (error.path) {
                    restError.fieldErrors.push(error);
                }
                else {
                    restError.errorCode = error.code;
                }
            });
        }
        catch (e) {
            restError.errorCode = 'unexpected-error';
        }
    }
    else {
        restError.errorCode = 'unexpected-error';
    }
    return restError;
}
function createOfflineRestError(xhr) {
    /* beautify ignore:start */
    return {
        status: xhr.status,
        fieldErrors: [],
        errorCode: "turnto-offline"
    };
    /* beautify ignore:end */
}
function populatePathValues(path, params) {
    if (params === void 0) { params = {}; }
    var fieldsInPathRegEx = /{(.*?)}/g;
    // globally replacing siteKey and locale without needing to pass in calls
    var replaceMap = {
        '{siteKey}': __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].siteKey,
        '{locale}': __WEBPACK_IMPORTED_MODULE_1_init_config__["b" /* turnToConfig */].locale
    };
    // this loop finds each path variable and adds to the replaceMap.
    // a path variable is surrounded by curly braces.
    // Example with siteKey and id: /{siteKey}/review/{id}
    var match;
    while (match = fieldsInPathRegEx.exec(path)) {
        var fieldName = match[1];
        if (fieldName !== 'siteKey' && fieldName !== 'locale') {
            replaceMap["{" + fieldName + "}"] = params[fieldName];
        }
    }
    // this regex and replace, replaces each path variable with its value
    var replaceRegEx = new RegExp(Object.keys(replaceMap).join("|"), "gi");
    return path.replace(replaceRegEx, (function (matched) { return replaceMap[matched]; }));
}
function call(method, path, parameters, requiredFields, queryFields, headerFields, body) {
    if (parameters === void 0) { parameters = {}; }
    if (body === void 0) { body = {}; }
    var queryParameters = {};
    var headers = {};
    requiredFields.forEach(function (fieldName) {
        if (parameters[fieldName] === undefined || parameters[fieldName] === null) {
            throw new Error("Missing required  parameter: " + fieldName);
        }
    });
    queryFields.forEach(function (fieldName) {
        if (parameters[fieldName] !== undefined && parameters[fieldName] !== null) {
            queryParameters[fieldName] = parameters[fieldName];
        }
    });
    headerFields.forEach(function (fieldName) {
        if (parameters[fieldName] !== undefined && parameters[fieldName] !== null) {
            headers[fieldName] = parameters[fieldName];
        }
    });
    var populatedPath = populatePathValues(path, parameters);
    return new Promise(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_0__http_client__["c" /* executeRequest */])(method, populatedPath, {
            body: body,
            headers: headers,
            params: queryParameters
        }).then(function (xhr) {
            var offline = xhr.getResponseHeader('turnto-offline');
            if (offline === 'true') {
                reject(createOfflineRestError(xhr));
            }
            else if (xhr.status === 200 || xhr.status === 201) {
                resolve(xhr.data);
            }
            else {
                reject((createRestError(xhr)));
            }
        }).catch(function (xhr) {
            reject(createRestError(xhr));
        });
    });
}
function callStatic(path, parameters, requiredFields) {
    if (parameters === void 0) { parameters = {}; }
    requiredFields.forEach(function (fieldName) {
        if (parameters[fieldName] === undefined || parameters[fieldName] === null) {
            throw new Error("Missing required  parameter: " + fieldName);
        }
    });
    var populatedPath = populatePathValues(path, parameters);
    return new Promise(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_0__http_client__["d" /* executeStaticRequest */])(populatedPath).then(function (xhr) {
            var offline = xhr.getResponseHeader('turnto-offline');
            if (offline === 'true') {
                reject(createOfflineRestError(xhr));
            }
            else if (xhr.status === 200) {
                resolve(xhr.data);
            }
            else {
                reject((createRestError(xhr)));
            }
        }).catch(function (xhr) {
            reject(createRestError(xhr));
        });
    });
}
/**
 * v5 Widget API
 * @class ApiService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
var ApiService = /** @class */ (function () {
    function ApiService() {
    }
    ApiService.prototype.uploadFile = function (path, formData, progressCallback) {
        return new Promise(function (resolve, reject) {
            Object(__WEBPACK_IMPORTED_MODULE_0__http_client__["c" /* executeRequest */])('POST', path, 
            // progressCallback function updates the progress as it's being uploaded
            {
                formData: formData,
                progressCallback: progressCallback
            }).then(function (xhr) {
                if (xhr.status === 200 || xhr.status === 201) {
                    resolve(xhr.data);
                }
                else {
                    reject((createRestError(xhr)));
                }
            }).catch(function (xhr) {
                reject(createRestError(xhr));
            });
        });
    };
    /**
     * Get article by id
     *
     * @method
     * @name ApiService#getArticleById
     * @param {integer} id -
     */
    ApiService.prototype.getArticleById = function (parameters) {
        return call('GET', '/{siteKey}/article/{id}/{locale}', parameters, ['id'], [], []);
    };
    /**
     * Retrieve catalog items
     *
     * @method
     * @name ApiService#getCatalogItems
     * @param {object} body -
     * {
     *   searchTerm:string
     *   excludeCatItemIds:array
     *   currentSku:string
     * }
     */
    ApiService.prototype.getCatalogItems = function (body) {
        return call('POST', '/{siteKey}/catalogItem/search', {}, [], [], [], body);
    };
    /**
     * Retrieve catalog items containing comments for the comments pinboard
     *
     * @method
     * @name ApiService#getCatalogItemsForCommentsPinboard
     * @param {string} skus -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {boolean} activeOnly -
     * @param {string} brands -
     * @param {string} tags -
     * @param {boolean} includeCommentsCount -
     * @param {boolean} includeReviewData -
     * @param {integer} maxDaysOld - Specify -1 to include all, regardless of age
     * @param {boolean} includeSyndicated -
     * @param {integer} minComments -
     * @param {integer} maxCommentsReturned -
     */
    ApiService.prototype.getCatalogItemsForCommentsPinboard = function (parameters) {
        return callStatic('/sitedata/{siteKey}/commentsPinboard/{skus}/{locale}/{offset}/{limit}/{activeOnly}/{brands}/{tags}/{includeCommentsCount}/{includeReviewData}/{maxDaysOld}/{includeSyndicated}/{minComments}/{maxCommentsReturned}', parameters, ['skus', 'offset', 'limit', 'activeOnly', 'brands', 'tags', 'includeCommentsCount', 'includeReviewData', 'maxDaysOld', 'includeSyndicated', 'minComments', 'maxCommentsReturned']);
    };
    /**
     * Save a new comment
     *
     * @method
     * @name ApiService#createComment
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {CreateCommentBody} body -
     */
    ApiService.prototype.createComment = function (parameters, body) {
        return call('POST', '/{siteKey}/comment', parameters, ['context-token', 'sku',], ['sku', 'checkoutSiteKey',], ['context-token',], body);
    };
    /**
     * Comments for chatter
     *
     * @method
     * @name ApiService#chatterComments
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} sort - Possible values are:
     * 0 (default) - by id, descending
     * 1 - by length of comment text, descending
    
     * @param {integer} minCharCount -
     * @param {integer} minWordCount -
     * @param {boolean} includeSyndicated -
     */
    ApiService.prototype.chatterComments = function (parameters) {
        return callStatic('/sitedata/{siteKey}/chatter/{sku}/{locale}/{offset}/{limit}/{sort}/{minCharCount}/{minWordCount}/{includeSyndicated}', parameters, ['sku', 'offset', 'limit', 'sort', 'minCharCount', 'minWordCount', 'includeSyndicated']);
    };
    /**
     * This is only intended to be done right after comment creation
     *
     * @method
     * @name ApiService#updateComment
     * @param {string} contextToken -
     * @param {integer} id -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {UpdateCommentBody} body -
     */
    ApiService.prototype.updateComment = function (parameters, body) {
        return call('PUT', '/{siteKey}/comment/{id}', parameters, ['context-token', 'id', 'sku',], ['sku', 'checkoutSiteKey',], ['context-token',], body);
    };
    /**
     * This is only intended to be done right after comment creation
     *
     * @method
     * @name ApiService#deleteComment
     * @param {string} contextToken -
     * @param {integer} id -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     */
    ApiService.prototype.deleteComment = function (parameters) {
        return call('DELETE', '/{siteKey}/comment/{id}', parameters, ['context-token', 'id', 'sku',], ['sku', 'checkoutSiteKey'], ['context-token',]);
    };
    /**
     * Top comments
     *
     * @method
     * @name ApiService#topComments
     * @param {string} skus - Comma separated list of skus
     * @param {integer} minCharCount -
     * @param {integer} minWordCount -
     * @param {string} tags - Comma separated list of tags
     * @param {boolean} includeSyndicated -
     */
    ApiService.prototype.topComments = function (parameters) {
        return callStatic('/sitedata/{siteKey}/topcomment/{skus}/{locale}/{minCharCount}/{minWordCount}/{tags}/{includeSyndicated}', parameters, ['skus', 'minCharCount', 'minWordCount', 'tags', 'includeSyndicated']);
    };
    /**
     * List of media
     *
     * @method
     * @name ApiService#mediaList
     * @param {string} skus -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} sort - Possible values are: MOST_VOTES, MOST_RECENT, and LONGEST
     * @param {boolean} includeProductSiblings -
     * @param {string} tags -
     * @param {integer} minCharCount -
     * @param {integer} minWordCount -
     * @param {boolean} includeSyndicated -
     */
    ApiService.prototype.mediaList = function (parameters) {
        return callStatic('/sitedata/{siteKey}/gallery/{skus}/{locale}/{offset}/{limit}/{sort}/{minCharCount}/{minWordCount}/{includeSyndicated}/{includeProductSiblings}/{tags}', parameters, ['skus', 'offset', 'limit', 'sort', 'includeProductSiblings', 'tags', 'minCharCount', 'minWordCount', 'includeSyndicated']);
    };
    /**
     * Vote for a media item
     *
     * @method
     * @name ApiService#voteForMedia
     * @param {integer} id -
     */
    ApiService.prototype.voteForMedia = function (parameters) {
        return call('POST', '/{siteKey}/media/{id}/vote', parameters, ['id'], [], []);
    };
    /**
     * Flag a media item as inappropriate
     *
     * @method
     * @name ApiService#flagMedia
     * @param {integer} id -
     * @param {string} reason - Possible values:
    *   ipViolation
    *   offensive
    *   offTopic
    *   spam
    
     */
    ApiService.prototype.flagMedia = function (parameters) {
        return call('POST', '/{siteKey}/media/{id}/flag', parameters, ['id', 'reason'], ['reason'], []);
    };
    /**
     * Save a batch of media items
     *
     * @method
     * @name ApiService#saveMedia
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {CreateMediaItemsBody} body -
     */
    ApiService.prototype.saveMedia = function (parameters, body) {
        return call('POST', '/{siteKey}/media/batch', parameters, ['context-token', 'sku',], ['sku', 'checkoutSiteKey',], ['context-token',], body);
    };
    /**
     * Initialization data for the share media flow (coming from rse)
     *
     * @method
     * @name ApiService#shareMediaInitData
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.shareMediaInitData = function (parameters) {
        return call('GET', '/{siteKey}/media/initData', parameters, ['sku',], ['sku', 'checkoutSiteKey', 'ssoProfileToken'], ['context-token',]);
    };
    /**
     * TODO - need to make this work or remove.  Currently using hard-coded call set in api-service called uploadFile
     *
     * @method
     * @name ApiService#uploadMedia
     * @param {file} file -
     * @param {string} uploadId -
     */
    ApiService.prototype.uploadMedia = function (parameters) {
        return call('POST', '/{siteKey}/media/upload', parameters, ['file', 'uploadId'], [], []);
    };
    /**
     * Post a video link for validation and return details
     *
     * @method
     * @name ApiService#addVideoLink
     * @param {string} url -
     */
    ApiService.prototype.addVideoLink = function (parameters) {
        return call('POST', '/{siteKey}/media/videoLink', parameters, ['url'], ['url'], []);
    };
    /**
     * Retrieve media for vc pinboard
     *
     * @method
     * @name ApiService#getMediaForVcPinboard
     * @param {string} skus -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {boolean} activeOnly -
     * @param {string} brands -
     * @param {string} tags -
     * @param {integer} sortOrder - Possible values are: MOST_VOTES, MOST_RECENT, and LONGEST
     * @param {boolean} includeReviewData -
     * @param {integer} minCaptionCharCount -
     * @param {integer} minCaptionWordCount -
     */
    ApiService.prototype.getMediaForVcPinboard = function (parameters) {
        return callStatic('/sitedata/{siteKey}/vcPinboard/{skus}/{locale}/{offset}/{limit}/{activeOnly}/{brands}/{tags}/{sortOrder}/{includeReviewData}/{minCaptionCharCount}/{minCaptionWordCount}', parameters, ['skus', 'offset', 'limit', 'activeOnly', 'brands', 'tags', 'sortOrder', 'includeReviewData', 'minCaptionCharCount', 'minCaptionWordCount']);
    };
    /**
     * List of questions
     *
     * @method
     * @name ApiService#questionsList
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} sort - Default value depends on site settings:
     * RECENT
     * OLDEST
     * BEST
     * MOST_ANSWERS
     * LEAST_ANSWERS
     * MOST_RECENT_ANSWER
     * OLDEST_ANSWER
    
     * @param {boolean} includeRelated -
     */
    ApiService.prototype.questionsList = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/d/question/{locale}/{offset}/{limit}/{sort}/{includeRelated}', parameters, ['sku', 'offset', 'limit', 'sort',]);
    };
    /**
     * List of related questions
     *
     * @method
     * @name ApiService#relatedQuestionsList
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} sort - Default value depends on site settings:
     * RECENT
     * OLDEST
     * BEST
     * MOST_ANSWERS
     * LEAST_ANSWERS
     * MOST_RECENT_ANSWER
     * OLDEST_ANSWER
    
     */
    ApiService.prototype.relatedQuestionsList = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/r/relatedquestion/{locale}/{offset}/{limit}/{sort}', parameters, ['sku', 'offset', 'limit', 'sort']);
    };
    /**
     * Create a question (anonymous or unconfirmed user)
     *
     * @method
     * @name ApiService#createQuestionAnonOrUnconfirmedUser
     * @param {string} qualifier -
     * @param {string} sku -
     * @param {CreateQuestionBody} body -
     */
    ApiService.prototype.createQuestionAnonOrUnconfirmedUser = function (parameters, body) {
        return call('POST', '/{siteKey}/question/inline/{qualifier}', parameters, ['qualifier', 'sku',], ['sku',], [], body);
    };
    /**
     * Create a question (confirmed user)
     *
     * @method
     * @name ApiService#createQuestionConfirmedUser
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {CreateQuestionBody} body -
     */
    ApiService.prototype.createQuestionConfirmedUser = function (parameters, body) {
        return call('POST', '/{siteKey}/question/inline/confirmed', parameters, ['context-token', 'sku',], ['sku',], ['context-token',], body);
    };
    /**
     * Create an answer
     *
     * @method
     * @name ApiService#createAnswer
     * @param {string} contextToken -
     * @param {string} qualifier - confirmed or unconfirmed
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {CreateAnswerBody} body -
     */
    ApiService.prototype.createAnswer = function (parameters, body) {
        return call('POST', '/{siteKey}/answer/inline/{qualifier}', parameters, ['sku',], ['sku', 'originSiteKey',], ['context-token',], body);
    };
    /**
     * Create an answer from an email
     *
     * @method
     * @name ApiService#createEmailAnswer
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {CreateAnswerBody} body -
     */
    ApiService.prototype.createEmailAnswer = function (parameters, body) {
        return call('POST', '/{siteKey}/answer/email', parameters, ['sku',], ['sku', 'originSiteKey',], ['context-token',], body);
    };
    /**
     * Initialization data for coming from question email to answer the question
     *
     * @method
     * @name ApiService#answerInitData
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.answerInitData = function (parameters) {
        return call('GET', '/{siteKey}/answer/initData', parameters, ['context-token', 'sku',], ['sku', 'ssoProfileToken'], ['context-token',]);
    };
    /**
     * Vote for a question
     *
     * @method
     * @name ApiService#voteQuestion
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {integer} id -
     * @param {object} body -
     * {
     *   up:number
     * }
     */
    ApiService.prototype.voteQuestion = function (parameters, body) {
        return call('POST', '/{siteKey}/question/{id}/vote', parameters, ['sku', 'id',], ['sku', 'originSiteKey',], [], body);
    };
    /**
     * Get question data by id
     *
     * @method
     * @name ApiService#getQuestionData
     * @param {string} originSiteKey -
     * @param {integer} id -
     */
    ApiService.prototype.getQuestionData = function (parameters) {
        return call('GET', '/{siteKey}/question/{id}/{locale}', parameters, ['id'], ['originSiteKey',], []);
    };
    /**
     * Flag an answer as inappropriate
     *
     * @method
     * @name ApiService#flagAnswer
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {integer} id -
     */
    ApiService.prototype.flagAnswer = function (parameters) {
        return call('POST', '/{siteKey}/answer/{id}/flag', parameters, ['sku', 'id'], ['sku', 'originSiteKey',], []);
    };
    /**
     * Vote for an answer
     *
     * @method
     * @name ApiService#voteAnswer
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {integer} id -
     * @param {object} body -
     * {
     *   up:number
     * }
     */
    ApiService.prototype.voteAnswer = function (parameters, body) {
        return call('POST', '/{siteKey}/answer/{id}/vote', parameters, ['sku', 'id',], ['sku', 'originSiteKey',], [], body);
    };
    /**
     * Create a reply to an answer
     *
     * @method
     * @name ApiService#createReply
     * @param {string} contextToken -
     * @param {string} qualifier - confirmed or unconfirmed
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {CreateReplyBody} body -
     */
    ApiService.prototype.createReply = function (parameters, body) {
        return call('POST', '/{siteKey}/reply/inline/{qualifier}', parameters, ['qualifier', 'sku',], ['sku', 'originSiteKey',], ['context-token',], body);
    };
    /**
     * Create a reply from an email
     *
     * @method
     * @name ApiService#createEmailReply
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {CreateReplyBody} body -
     */
    ApiService.prototype.createEmailReply = function (parameters, body) {
        return call('POST', '/{siteKey}/reply/email', parameters, ['sku',], ['sku', 'originSiteKey',], ['context-token',], body);
    };
    /**
     * Initialization data for coming from answer or reply email to reply
     *
     * @method
     * @name ApiService#replyInitData
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.replyInitData = function (parameters) {
        return call('GET', '/{siteKey}/reply/initData', parameters, ['context-token', 'sku',], ['sku', 'ssoProfileToken'], ['context-token',]);
    };
    /**
     * Save a new review by an unconfirmed user
     *
     * @method
     * @name ApiService#saveReviewUnconfirmed
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {ReviewForm} body -
     */
    ApiService.prototype.saveReviewUnconfirmed = function (parameters, body) {
        return call('POST', '/{siteKey}/review/inline/unconfirmed', parameters, ['sku',], ['sku', 'checkoutSiteKey',], [], body);
    };
    /**
     * Save a new review by a confirmed (logged-in) user
     *
     * @method
     * @name ApiService#saveReviewConfirmed
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {ReviewForm} body -
     */
    ApiService.prototype.saveReviewConfirmed = function (parameters, body) {
        return call('POST', '/{siteKey}/review/inline/confirmed', parameters, ['context-token', 'sku',], ['sku', 'checkoutSiteKey',], ['context-token',], body);
    };
    /**
     * Save a new review from an RSE
     *
     * @method
     * @name ApiService#saveReviewRse
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {ReviewForm} body -
     */
    ApiService.prototype.saveReviewRse = function (parameters, body) {
        return call('POST', '/{siteKey}/review/email', parameters, ['context-token', 'sku',], ['sku', 'checkoutSiteKey',], ['context-token',], body);
    };
    /**
     * Initialization data for the review form
     *
     * @method
     * @name ApiService#reviewInitData
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.reviewInitData = function (parameters) {
        return call('GET', '/{siteKey}/review/initData', parameters, ['sku',], ['sku', 'checkoutSiteKey', 'ssoProfileToken'], ['context-token',]);
    };
    /**
     * Initialization data for the review form coming from RSE
     *
     * @method
     * @name ApiService#rseReviewInitData
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} ssoProfileToken -
     * @param {number} lastSeenSrDate - Last seen seller rating date in milliseconds UTC
     * @param {string} checkoutSiteKey -
     */
    ApiService.prototype.rseReviewInitData = function (parameters) {
        return call('GET', '/{siteKey}/review/rseInitData', parameters, ['sku',], ['sku', 'ssoProfileToken', 'lastSeenSrDate', 'checkoutSiteKey'], ['context-token',]);
    };
    /**
     * List of reviews
     *
     * @method
     * @name ApiService#reviewsList
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} filters - Encoded JSON of filters.  Example before being encoded: {"md":true,"rt":[1,2,3],"sp":[{"7":[2,3]},{"14":[1]}],"dm":[{"5":[1,4]},{"3":[2,3,4]}],"att":[{"2":[1]},{"3":[1,2]}]}
     * @param {string} sort - Default value and which options are available depends on site settings:
     * mostRecent
     * mostHelpful (formerly bestR)
     * expert (expert reviews first)
     * staff (staff reviews first)
     * topContributors (reviews first)
     * highestRated
     * lowestRated
     * mostRelevant
     * photosVideos
     * oldest
    
     * @param {boolean} includeRelated -
     * @param {boolean} includeFilters -
     * @param {string} searchText -
     */
    ApiService.prototype.reviewsList = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/d/review/{locale}/{offset}/{limit}/{filters}/{sort}/{includeRelated}/{includeFilters}/{searchText}', parameters, ['sku', 'offset', 'limit', 'filters', 'sort', 'includeRelated', 'includeFilters',]);
    };
    /**
     * List of related reviews
     *
     * @method
     * @name ApiService#relatedReviewsList
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} sort - Default value and which options are available depends on site settings:
     * mostRecent
     * mostHelpful (formerly bestR)
     * expert (expert reviews first)
     * staff (staff reviews first)
     * topContributors (reviews first)
     * highestRated
     * lowestRated
     * mostRelevant
     * photosVideos
     * oldest
    
     */
    ApiService.prototype.relatedReviewsList = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/r/relatedReview/{locale}/{offset}/{limit}/{sort}', parameters, ['sku', 'offset', 'limit', 'sort']);
    };
    /**
     * Spectrum of reviews
     *
     * @method
     * @name ApiService#spectrum
     * @param {string} sku -
     */
    ApiService.prototype.spectrum = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/d/review/spectrum/{locale}', parameters, ['sku']);
    };
    /**
     * Send deviceFingerprint to be stored on the review
     *
     * @method
     * @name ApiService#saveReviewFingerprint
     * @param {string} contextToken -
     * @param {integer} id -
     * @param {object} body -
     * {
     *   deviceFingerprint:string
     * }
     */
    ApiService.prototype.saveReviewFingerprint = function (parameters, body) {
        return call('PUT', '/{siteKey}/review/{id}/fingerprint', parameters, ['id',], [], ['context-token',], body);
    };
    /**
     * Flag a review as inappropriate
     *
     * @method
     * @name ApiService#flagReview
     * @param {integer} id -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     */
    ApiService.prototype.flagReview = function (parameters) {
        return call('POST', '/{siteKey}/review/{id}/flag', parameters, ['id', 'sku',], ['sku', 'checkoutSiteKey'], []);
    };
    /**
     * Registers a down vote for a review
     *
     * @method
     * @name ApiService#voteForReview
     * @param {integer} id -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {object} body -
     * {
     *   up:number
     *   down:number
     * }
     */
    ApiService.prototype.voteForReview = function (parameters, body) {
        return call('POST', '/{siteKey}/review/{id}/vote', parameters, ['id', 'sku',], ['sku', 'checkoutSiteKey',], [], body);
    };
    /**
     * Get review data by id
     *
     * @method
     * @name ApiService#getReviewData
     * @param {string} originSiteKey -
     * @param {integer} id -
     */
    ApiService.prototype.getReviewData = function (parameters) {
        return call('GET', '/{siteKey}/review/{id}/{locale}', parameters, ['id'], ['originSiteKey',], []);
    };
    /**
     *
     *
     * @method
     * @name ApiService#reviewsSummary
     * @param {string} sku -
     */
    ApiService.prototype.reviewsSummary = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/d/review/summary/{locale}', parameters, ['sku']);
    };
    /**
     * This is called when coming from a successful inbox submission
     *
     * @method
     * @name ApiService#checkSellerRatingEligibile
     * @param {string} contextToken -
     * @param {number} lastSeenSrDate - Last seen seller rating date in milliseconds UTC
     */
    ApiService.prototype.checkSellerRatingEligibile = function (parameters) {
        return call('GET', '/{siteKey}/sellerRating/checkEligible', parameters, ['context-token',], ['lastSeenSrDate'], ['context-token',]);
    };
    /**
     * Save a new seller rating coming from solicitation email
     *
     * @method
     * @name ApiService#saveSellerRating
     * @param {string} contextToken -
     * @param {string} submitType -
     * @param {SellerRatingForm} body -
     */
    ApiService.prototype.saveSellerRating = function (parameters, body) {
        return call('POST', '/{siteKey}/sellerRating/{submitType}', parameters, ['context-token', 'submitType',], [], ['context-token',], body);
    };
    /**
     * Initialization data for the seller rating form
     *
     * @method
     * @name ApiService#srInitData
     * @param {string} contextToken -
     * @param {string} initType -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.srInitData = function (parameters) {
        return call('GET', '/{siteKey}/sellerRating/{initType}', parameters, ['initType',], ['ssoProfileToken'], ['context-token',]);
    };
    /**
     * Post a transaction (js feed)
     *
     * @method
     * @name ApiService#createTransaction
     * @param {CreateTransactionBody} body -
     */
    ApiService.prototype.createTransaction = function (body) {
        return call('POST', '/{siteKey}/transaction/{locale}', {}, [], [], [], body);
    };
    /**
     * Post a transaction (js feed) and get items for user to comment on
     *
     * @method
     * @name ApiService#createTransactionAndGetItemsForComment
     * @param {CreateTransactionBody} body -
     */
    ApiService.prototype.createTransactionAndGetItemsForComment = function (body) {
        return call('POST', '/{siteKey}/transaction/itemsForComment/{locale}', {}, [], [], [], body);
    };
    /**
     * Submits user registration information
     *
     * @method
     * @name ApiService#registerUser
     * @param {string} qualifier -
     * @param {string} registerFor -
     * @param {RegisterUserBody} body -
     */
    ApiService.prototype.registerUser = function (parameters, body) {
        return call('POST', '/{siteKey}/user/register/{qualifier}/{registerFor}', parameters, ['qualifier', 'registerFor',], [], [], body);
    };
    /**
     * Call to resend the confirmation email just sent
     *
     * @method
     * @name ApiService#resendConfirmation
     * @param {string} qualifier -
     * @param {string} registerFor -
     * @param {object} body -
     * {
     *   token:string
     * }
     */
    ApiService.prototype.resendConfirmation = function (parameters, body) {
        return call('POST', '/{siteKey}/user/register/{qualifier}/resend/{registerFor}', parameters, ['qualifier', 'registerFor',], [], [], body);
    };
    /**
     * Get user's reviews
     *
     * @method
     * @name ApiService#getUserReviews
     * @param {integer} id -
     * @param {integer} offset -
     * @param {integer} limit -
     */
    ApiService.prototype.getUserReviews = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/review/{locale}', parameters, ['id',], ['offset', 'limit'], []);
    };
    /**
     * Get user's questions
     *
     * @method
     * @name ApiService#getUserQuestions
     * @param {integer} id -
     * @param {integer} offset -
     * @param {integer} limit -
     */
    ApiService.prototype.getUserQuestions = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/question/{locale}', parameters, ['id',], ['offset', 'limit'], []);
    };
    /**
     * Get user's answers
     *
     * @method
     * @name ApiService#getUserAnswers
     * @param {integer} id -
     * @param {integer} offset -
     * @param {integer} limit -
     */
    ApiService.prototype.getUserAnswers = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/answer/{locale}', parameters, ['id',], ['offset', 'limit'], []);
    };
    /**
     * Get user's media
     *
     * @method
     * @name ApiService#getUserMedia
     * @param {integer} id -
     * @param {integer} offset -
     * @param {integer} limit -
     */
    ApiService.prototype.getUserMedia = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/media/{locale}', parameters, ['id',], ['offset', 'limit'], []);
    };
    /**
     * Get user's comments
     *
     * @method
     * @name ApiService#getUserComments
     * @param {integer} id -
     * @param {integer} offset -
     * @param {integer} limit -
     */
    ApiService.prototype.getUserComments = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/comment/{locale}', parameters, ['id',], ['offset', 'limit'], []);
    };
    /**
     * Get statistics for user submitted ugc
     *
     * @method
     * @name ApiService#getUserUgcStats
     * @param {integer} id -
     */
    ApiService.prototype.getUserUgcStats = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/ugcStats/{locale}', parameters, ['id'], [], []);
    };
    /**
     * Get user profile
     *
     * @method
     * @name ApiService#getUserProfile
     * @param {string} contextToken -
     * @param {integer} id -
     */
    ApiService.prototype.getUserProfile = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/profile/{locale}', parameters, ['context-token', 'id'], [], ['context-token',]);
    };
    /**
     * This can only be done by the logged in user.
     *
     * @method
     * @name ApiService#updateUserProfile
     * @param {string} contextToken -
     * @param {integer} id -
     * @param {UserProfile} body -
     */
    ApiService.prototype.updateUserProfile = function (parameters, body) {
        return call('PUT', '/{siteKey}/user/{id}/profile/{locale}', parameters, ['context-token', 'id',], [], ['context-token',], body);
    };
    /**
     * Get user identities by user id
     *
     * @method
     * @name ApiService#getUserIdentities
     * @param {integer} id - User id
     */
    ApiService.prototype.getUserIdentities = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/identity', parameters, ['id'], [], []);
    };
    /**
     * This can only be done by the logged in user.
     *
     * @method
     * @name ApiService#createUserIdentity
     * @param {integer} id - User id
     * @param {CreateUserIdentityBody} body -
     */
    ApiService.prototype.createUserIdentity = function (parameters, body) {
        return call('POST', '/{siteKey}/user/{id}/identity', parameters, ['id',], [], [], body);
    };
    /**
     * This really only updates the isPrimary property
     *
     * @method
     * @name ApiService#updateUserIdentity
     * @param {integer} id - User id
     * @param {integer} identityId - User identity id
     * @param {UpdateUserIdentityBody} body -
     */
    ApiService.prototype.updateUserIdentity = function (parameters, body) {
        return call('PUT', '/{siteKey}/user/{id}/identity/{identityId}', parameters, ['id', 'identityId',], [], [], body);
    };
    /**
     * Delete a user identity
     *
     * @method
     * @name ApiService#deleteUserIdentity
     * @param {integer} id - User id
     * @param {integer} identityId - User identity id
     */
    ApiService.prototype.deleteUserIdentity = function (parameters) {
        return call('DELETE', '/{siteKey}/user/{id}/identity/{identityId}', parameters, ['id', 'identityId'], [], []);
    };
    /**
     * Get do more content by user id
     *
     * @method
     * @name ApiService#getDoMoreContent
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {integer} questionId -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.getDoMoreContent = function (parameters) {
        return call('GET', '/{siteKey}/user/doMore/{locale}', parameters, ['context-token', 'sku',], ['sku', 'offset', 'limit', 'questionId', 'ssoProfileToken'], ['context-token',]);
    };
    /**
     * Instant answers search.
     *
     * @method
     * @name ApiService#instantAnswerSearch
     * @param {SearchBody} body -
     */
    ApiService.prototype.instantAnswerSearch = function (body) {
        return call('POST', '/{siteKey}/answer/search', {}, [], [], [], body);
    };
    /**
     * Counts for each ugc type, formally itemjs
     *
     * @method
     * @name ApiService#ugcCounts
     * @param {string} sku -
     */
    ApiService.prototype.ugcCounts = function (parameters) {
        return call('GET', '/sitedata/{siteKey}/{sku}/d/ugc/counts/{locale}', parameters, ['sku'], ['sku'], []);
    };
    /**
     * Complete action in 'ssoRegDone' js callback by partner site after sso
     *
     * @method
     * @name ApiService#completeSsoAction
     * @param {string} sku -
     * @param {SsoRequest} body -
     */
    ApiService.prototype.completeSsoAction = function (parameters, body) {
        return call('POST', '/{siteKey}/user/sso', parameters, ['sku',], ['sku',], [], body);
    };
    return ApiService;
}());

/* harmony default export */ __webpack_exports__["a"] = (new ApiService());

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__submission_modal__ = __webpack_require__(28);




var SUBMISSION_MODAL_ID = 'tt-submission-modal';
var wasLoaded = false;
/* harmony default export */ __webpack_exports__["a"] = ({
    // If it does not already exist, this creates a div as a descendant of body with
    // an id used for submission-modal. It then mounts the submission-modal component
    // if not already mounted.
    load: function () {
        return new Promise(function (resolve) {
            if (wasLoaded) {
                __WEBPACK_IMPORTED_MODULE_2_store_submission_store__["b" /* default */].isOpen = true;
                resolve();
            }
            else if (!document.getElementById(SUBMISSION_MODAL_ID)) {
                __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].appendDivToBody(SUBMISSION_MODAL_ID);
                new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
                    el: "#" + SUBMISSION_MODAL_ID,
                    render: function (h) { return h(__WEBPACK_IMPORTED_MODULE_3__submission_modal__["a" /* default */], {
                        attrs: { id: SUBMISSION_MODAL_ID }
                    }); },
                    created: function () {
                        __WEBPACK_IMPORTED_MODULE_2_store_submission_store__["b" /* default */].isOpen = true;
                    }
                });
                wasLoaded = true;
                resolve();
            }
            else {
                resolve();
            }
        });
    }
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MODERATION_URL; });
/* harmony export (immutable) */ __webpack_exports__["c"] = encodeArray;
/* harmony export (immutable) */ __webpack_exports__["e"] = getProductImageUrl;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TTDAT_PARAM_NAME; });
/* harmony export (immutable) */ __webpack_exports__["h"] = parseTTdat;
/* harmony export (immutable) */ __webpack_exports__["j"] = setLastSeenSellerRatingDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = getLastSeenSellerRatingDate;
/* harmony export (immutable) */ __webpack_exports__["g"] = getSessionVarInt;
/* harmony export (immutable) */ __webpack_exports__["f"] = getSessionVar;
/* harmony export (immutable) */ __webpack_exports__["i"] = removeSessionVar;
/* harmony export (immutable) */ __webpack_exports__["k"] = setSessionVar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_browser_utils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_config__ = __webpack_require__(3);


var ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;
var SR_LAST_SEEN_DATE_COOKIE_NAME = 'TT_SRLSD'; // SR: Seller Rating
var MODERATION_URL = __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].moderationHost;
/**
 * Used for service calls that are passing an array on the path
 * @param arr
 */
function encodeArray(arr) {
    return Array.isArray(arr) && arr.length > 0 ? encodeURIComponent(arr.join(',')) : '_ALL_';
}
function getProductImageUrl(catItem, size, siblingSiteKey) {
    if (size === void 0) { size = 'L'; }
    var imgSiteKey = siblingSiteKey || __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].siteKey;
    return __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].imageStoreBase + "/item/" + imgSiteKey + "/" +
        ("" + catItem.imageId + size + ".png");
}
var TTDAT_PARAM_NAME = 'ttdat';
function parseTTdat(ttdat) {
    var data = {};
    if (ttdat) {
        // Base64 encoded JSON data (user, catItemId, etc)
        var parsedTTdat = JSON.parse(atob(ttdat));
        data = {
            user: !parsedTTdat.u ? null : {
                id: parsedTTdat.u,
                firstName: parsedTTdat.f,
                lastName: parsedTTdat.l,
                nickName: parsedTTdat.n,
                isModerator: parsedTTdat.m || false
            },
            catItemId: parsedTTdat.c
        };
    }
    return data;
}
function setLastSeenSellerRatingDate() {
    // setting to now in milliseconds UTC, expiring in a year
    Object(__WEBPACK_IMPORTED_MODULE_0_util_browser_utils__["l" /* setCookie */])(SR_LAST_SEEN_DATE_COOKIE_NAME, Date.now(), ONE_YEAR_SECONDS);
}
function getLastSeenSellerRatingDate() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_util_browser_utils__["c" /* getCookie */])(SR_LAST_SEEN_DATE_COOKIE_NAME);
}
/**
 * Utility to retrieve int value from sessionStorage
 * @param type
 * @param id
 */
function getSessionVarInt(type, id) {
    if (window.sessionStorage.getItem(type + "_" + id)) {
        return parseInt(window.sessionStorage.getItem(type + "_" + id));
    }
    return null;
}
function getSessionVar(type, id) {
    return window.sessionStorage.getItem(type + "_" + id);
}
function removeSessionVar(type, id) {
    window.sessionStorage.removeItem(type + "_" + id);
}
function setSessionVar(type, id, value) {
    window.sessionStorage.setItem(type + "_" + id, value);
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_objects_popover_popover__ = __webpack_require__(19);



var POPOVER_CONTAINER_ID = 'tt-standalone-popover';
/**
 * This is intended to be used for when a user first comes to the page.  If the popover shows
 * at a later time, then should be shown as part of the widget it applies to instead of as a
 * standalone.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    // If it does not already exist, this creates a div as a descendant of body with
    // an id used for a standalone popover message. It then mounts the popover component
    // if not already mounted.
    load: function (data) {
        return new Promise(function (resolve) {
            __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].appendDivToBody(POPOVER_CONTAINER_ID);
            new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
                el: "#" + POPOVER_CONTAINER_ID,
                data: function () { return { showPopover: true }; },
                render: function (h) {
                    var _this = this;
                    if (this.showPopover) {
                        return h(__WEBPACK_IMPORTED_MODULE_2_objects_popover_popover__["a" /* default */], {
                            attrs: { id: POPOVER_CONTAINER_ID },
                            on: {
                                close: function () {
                                    _this.showPopover = false;
                                    __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].removeFromBody(POPOVER_CONTAINER_ID);
                                }
                            },
                            props: {
                                ariaLabel: data.label || '',
                                message: data.message,
                                type: data.type || 'success',
                                autoClose: data.autoClose || false
                            },
                            style: {
                                top: '25%'
                            }
                        });
                    }
                }
            });
            resolve();
        });
    }
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = processSsoRegDone;
/* harmony export (immutable) */ __webpack_exports__["g"] = ssoCreateReview;
/* harmony export (immutable) */ __webpack_exports__["e"] = ssoCreateQuestion;
/* harmony export (immutable) */ __webpack_exports__["d"] = ssoCreateAnswer;
/* harmony export (immutable) */ __webpack_exports__["f"] = ssoCreateReply;
/* harmony export (immutable) */ __webpack_exports__["h"] = ssoGetLoggedInData;
/* harmony export (immutable) */ __webpack_exports__["i"] = ssoGetLoggedInDataForReview;
/* harmony export (immutable) */ __webpack_exports__["b"] = processLoggedInDataDone;
/* harmony export (immutable) */ __webpack_exports__["a"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_service__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_widgets_standalone_popover_standalone_popover_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__msg__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_init_global_config__ = __webpack_require__(5);







function encodeSsoContext(ssoContext) {
    return btoa(JSON.stringify(ssoContext));
}
function processSsoRegDone(params) {
    var ssoContextData = parseSsoContext(params.context);
    if (params.userDataToken === null || params.userDataToken === '') {
        if (ssoContextData.action === 'QUESTION_CREATE' && __WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].isAllowAnon()) {
            __WEBPACK_IMPORTED_MODULE_4_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({ message: Object(__WEBPACK_IMPORTED_MODULE_5__msg__["a" /* default */])('ia.reg.skipped'), autoClose: true });
        }
        return;
    }
    __WEBPACK_IMPORTED_MODULE_0__api_service__["a" /* default */].completeSsoAction({
        sku: ssoContextData.sku
    }, {
        submissionToken: ssoContextData.submissionToken,
        action: ssoContextData.action,
        userDataToken: params.userDataToken
    }).then(function (ssoResponse) {
        // Review submission - purchase required case
        if (ssoContextData.action === 'REVIEW_CREATE' && __WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].isPurchaseReq()) {
            var launchData = {
                startAction: 'review',
                fromSso: true,
                source: ssoContextData.source,
                ssoToken: ssoResponse.token,
                starSelected: typeof ssoContextData.rating === 'number' ? ssoContextData.rating : undefined
            };
            __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].startRevFlow(ssoContextData.sku, __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, { page: 'review-form', props: {} }, launchData);
            __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__["a" /* default */].load();
        }
        else {
            var messageType = 'review';
            switch (ssoContextData.action) {
                case 'QUESTION_CREATE':
                    messageType = __WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].isAllowAnon() ? 'questionAnonSso' : 'question';
                    break;
                case 'ANSWER_CREATE':
                    messageType = 'answer';
                    break;
                case 'REPLY_CREATE': messageType = 'reply';
            }
            __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].launchData = { ssoToken: ssoResponse.token };
            __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].currentPage = {
                page: 'do-more',
                props: {
                    msgType: messageType,
                    questionId: ssoContextData.questionId || null
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__["a" /* default */].load();
        }
        // stops spinner on write review button(s)
        __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].isLaunchingWriteReview = false;
    }).catch(function (e) {
        var errorMsgKey = e.errorCode === 'item-already-reviewed'
            ? 'revForm.alreadyReviewed.message'
            : e.errorCode === 'turnto-offline' ? 'offline.error' : 'unexpected.error';
        __WEBPACK_IMPORTED_MODULE_4_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({
            message: Object(__WEBPACK_IMPORTED_MODULE_5__msg__["a" /* default */])(errorMsgKey), type: 'error', autoClose: true
        });
    });
}
function ssoCreateReview(sku, source, submissionToken, rating) {
    if (submissionToken === void 0) { submissionToken = null; }
    if (rating === void 0) { rating = null; }
    switch (__WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].authSettings.review) {
        case 1:
            ssoUserData(sku, 'REVIEW_CREATE', 'REGISTRATION_REQUIRED', submissionToken, source, rating);
            break;
        case 3:
            ssoUserData(sku, 'REVIEW_CREATE', 'CONFIRMATION_REQUIRED', submissionToken, source, rating);
            break;
        case 4:
            ssoUserData(sku, 'REVIEW_CREATE', 'PURCHASE_REQUIRED', submissionToken, source, rating);
    }
}
function ssoCreateQuestion(sku, submissionToken) {
    if (submissionToken === void 0) { submissionToken = null; }
    switch (__WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].authSettings.question) {
        case 1:
            ssoUserData(sku, 'QUESTION_CREATE', 'ANONYMOUS', submissionToken);
            break;
        case 2:
            ssoUserData(sku, 'QUESTION_CREATE', 'REGISTRATION_REQUIRED', submissionToken);
            break;
        case 3:
            ssoUserData(sku, 'QUESTION_CREATE', 'CONFIRMATION_REQUIRED', submissionToken);
    }
}
function ssoCreateAnswer(sku, submissionToken, questionId) {
    if (questionId === void 0) { questionId = null; }
    switch (__WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].authSettings.answerReply) {
        case 1:
            ssoUserData(sku, 'ANSWER_CREATE', 'REGISTRATION_REQUIRED', submissionToken, null, null, questionId);
            break;
        case 2:
            ssoUserData(sku, 'ANSWER_CREATE', 'CONFIRMATION_REQUIRED', submissionToken, null, null, questionId);
    }
}
function ssoCreateReply(sku, submissionToken) {
    switch (__WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].authSettings.answerReply) {
        case 1:
            ssoUserData(sku, 'REPLY_CREATE', 'REGISTRATION_REQUIRED', submissionToken);
            break;
        case 2:
            ssoUserData(sku, 'REPLY_CREATE', 'CONFIRMATION_REQUIRED', submissionToken);
    }
}
function ssoGetLoggedInData(sku, page, launchData, launchType) {
    var ssoContext = {};
    ssoContext.sku = sku;
    ssoContext.page = page;
    ssoContext.launchData = launchData;
    ssoContext.launchType = launchType;
    var encodedSsoContext = encodeSsoContext(ssoContext);
    __WEBPACK_IMPORTED_MODULE_2_init_config__["b" /* turnToConfig */].sso.loggedInDataFn(encodedSsoContext);
}
function ssoGetLoggedInDataForReview(sku, source, rating) {
    if (rating === void 0) { rating = null; }
    ssoGetLoggedInData(sku, { page: 'review-form', props: {} }, {
        startAction: 'review',
        source: typeof source === 'number' ? source : undefined,
        starSelected: typeof rating === 'number' ? rating : undefined
    }, 'rev');
}
function processLoggedInDataDone(params) {
    var ssoContextData = parseSsoContext(params.context);
    if (!!params.loggedInData) {
        ssoContextData.launchData.ssoProfileToken = params.loggedInData;
    }
    if (ssoContextData.launchType === 'qa') {
        __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].startQaFlow(ssoContextData.sku, __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, ssoContextData.page, ssoContextData.launchData);
    }
    else if (ssoContextData.launchType === 'sr') {
        __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].startSellerRatingFlow(__WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, ssoContextData.page, ssoContextData.launchData);
    }
    else {
        __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].startRevFlow(ssoContextData.sku, __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, ssoContextData.page, ssoContextData.launchData);
    }
    __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__["a" /* default */].load();
    // stops spinner on write review button(s)
    __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].isLaunchingWriteReview = false;
}
function logout() {
    if (__WEBPACK_IMPORTED_MODULE_2_init_config__["b" /* turnToConfig */].sso.logout) {
        __WEBPACK_IMPORTED_MODULE_2_init_config__["b" /* turnToConfig */].sso.logout();
    }
}
function ssoUserData(sku, action, authSetting, submissionToken, source, rating, questionId) {
    if (submissionToken === void 0) { submissionToken = null; }
    if (source === void 0) { source = null; }
    if (rating === void 0) { rating = null; }
    if (questionId === void 0) { questionId = null; }
    var ssoContext = {};
    ssoContext.action = action;
    ssoContext.authSetting = authSetting;
    ssoContext.sku = sku;
    ssoContext.submissionToken = submissionToken;
    if (typeof source === 'number') {
        ssoContext.source = source;
    }
    if (typeof rating === 'number') {
        ssoContext.rating = rating;
    }
    if (typeof questionId === 'number') {
        ssoContext.questionId = questionId;
    }
    var encodedSsoContext = encodeSsoContext(ssoContext);
    __WEBPACK_IMPORTED_MODULE_2_init_config__["b" /* turnToConfig */].sso.userDataFn(encodedSsoContext);
}
function parseSsoContext(ssoContext) {
    var data = {};
    if (ssoContext) {
        // Base64 encoded JSON data (submissionToken, action)
        data = JSON.parse(atob(ssoContext));
    }
    return data;
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loadLoggedInUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = loginUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = logoutUser;
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_global_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_browser_utils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_turnto_utils__ = __webpack_require__(11);



var USER_TOKEN_COOKIE_NAME = 'TT_USER_TOKEN';
var COOKIE_DELIMITER = '|';
function getUserAndToken() {
    var cookieValue = Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["c" /* getCookie */])(USER_TOKEN_COOKIE_NAME);
    if (cookieValue) {
        var cookieParts = cookieValue.split(COOKIE_DELIMITER);
        return { userToken: cookieParts[0], user: Object(__WEBPACK_IMPORTED_MODULE_2_util_turnto_utils__["h" /* parseTTdat */])(cookieParts[1]).user };
    }
    return { userToken: null, user: null };
}
// to be called when first coming to the page to load logged-in user info if logged-in.
// Can also be used to revalidate.  In other words, log out user if token expired.
function loadLoggedInUser() {
    __WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].user = getUserAndToken().user;
}
/**
 * Logs in a user by setting the token in a cookie and sets the user with the passed in user.
 * Also need ttdat, which contains user data. Storing in cookie for the case where the user
 * refreshes or goes to another page.  Can then parse out the user info in "loadLoggedInUser".
 * @param token
 * @param ttdat
 */
function loginUser(token, ttdat) {
    __WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].user = Object(__WEBPACK_IMPORTED_MODULE_2_util_turnto_utils__["h" /* parseTTdat */])(ttdat).user;
    var currentCookieValue = Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["c" /* getCookie */])(USER_TOKEN_COOKIE_NAME);
    var cookieTokenValue = currentCookieValue ? currentCookieValue.split(COOKIE_DELIMITER)[0] : '';
    // only want to set cookie if it doesn't exist or not the same.  Don't want to reset due to
    // expiration period
    if (cookieTokenValue !== token) {
        // setting to expire in 24 hours (86400 seconds)
        Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["l" /* setCookie */])(USER_TOKEN_COOKIE_NAME, "" + token + COOKIE_DELIMITER + ttdat, 86400);
    }
}
// Clears the user data and removes the user token
function logoutUser() {
    __WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].user = null;
    Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["b" /* dropCookie */])(USER_TOKEN_COOKIE_NAME);
}
function getUserToken() {
    var _a = getUserAndToken(), user = _a.user, userToken = _a.userToken;
    __WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].user = user;
    return userToken || '';
}


/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var global_commands_namespaceObject = {};
__webpack_require__.d(global_commands_namespaceObject, "set", function() { return set; });
__webpack_require__.d(global_commands_namespaceObject, "initialize", function() { return initialize; });
__webpack_require__.d(global_commands_namespaceObject, "setLogLevel", function() { return setLogLevel; });
__webpack_require__.d(global_commands_namespaceObject, "setLogTrace", function() { return setLogTrace; });
__webpack_require__.d(global_commands_namespaceObject, "ssoRegDone", function() { return ssoRegDone; });
__webpack_require__.d(global_commands_namespaceObject, "loggedInDataFnDone", function() { return loggedInDataFnDone; });

// EXTERNAL MODULE: ./src/util/logger.ts
var logger = __webpack_require__(13);

// EXTERNAL MODULE: ./src/init/global-store.ts
var global_store = __webpack_require__(6);

// EXTERNAL MODULE: ./src/services/sso-service.ts
var sso_service = __webpack_require__(14);

// CONCATENATED MODULE: ./src/init/global-commands.ts



// widgets affected by a change in sku
var SET_TYPES = ['chatter', 'instant-answers', 'qa', 'reviews-summary', 'reviews-list'];
function set(params) {
    if (!params || !params.sku) {
        logger["a" /* default */].error('Must specify sku for "set" (e.g. {sku: "abc"})');
        return;
    }
    var previousSku = global_store["a" /* default */].sku;
    global_store["a" /* default */].sku = params.sku;
    // if the sku changed, check to make sure the affected widgets are loaded, if not load them
    if (previousSku !== global_store["a" /* default */].sku) {
        global_store["a" /* default */].loaders.forEach(function (loader) {
            if (SET_TYPES.indexOf(loader.type) > -1 && !loader.getInstance()) {
                loader.initialize();
            }
        });
    }
}
// Used to load widgets after the page has loaded.  Covers case where divs do not exist on the
// page by the time dom is ready.  Can also be used in SPA situation where the html holding the
// widgets is removed and replaced with a new dom.
function initialize(widgetType) {
    global_store["a" /* default */].loaders.forEach(function (loader) {
        // not all widgets have an initialize functiion (e.g. top-comments, feed-comment-capture)
        if (typeof loader.initialize === 'function' && (!widgetType || widgetType === loader.type)) {
            loader.initialize();
        }
    });
}
function setLogLevel(level) {
    logger["b" /* setLogLevel */](level);
}
function setLogTrace(logTrace) {
    logger["c" /* setLogTrace */](logTrace);
}
// context is a base64 encoded json containing submissionToken, action, sku and optionally rating
function ssoRegDone(params) {
    if (!params || !params.context) {
        logger["a" /* default */].error('Must specify context for "ssoRegDone" (e.g. {context: "abc"})');
        return;
    }
    Object(sso_service["c" /* processSsoRegDone */])(params);
}
// context is a base64 encoded json containing sku and optionally rating
function loggedInDataFnDone(params) {
    if (!params || !params.context) {
        logger["a" /* default */].error('Must specify context for "loggedInDataFnDone" (e.g. {context: "abc"})');
        return;
    }
    Object(sso_service["b" /* processLoggedInDataDone */])(params);
}

// CONCATENATED MODULE: ./src/init/command-queue.ts
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return widgetLibraries; });


// An array of commands submitted by the client
var queue;
// Help make sure commands are not executed twice
var isProcessingQueue = false;
/**
 * Called by the page entry js once the widgets have been initialized, but not necessarily mounted
 */
function init() {
    // determine the name of the command function the client is using
    var cmdObjName = window.TurnToCmdObjectName || 'TurnToCmd';
    // get the commands that already queued up
    queue = window[cmdObjName] ? (window[cmdObjName].q || []) : [];
    // reassign the command object to point to internal function
    window[cmdObjName] = queueAndRunCommands;
    // call to run commands in case any are already in the queue
    runCommands();
}
/**
 * Widget loaders assign the function calls that can be made
 */
var widgetLibraries = {
    chatter: {},
    commentsPinboard: {},
    commentsPinboardTeaser: {},
    feed: {},
    gallery: {},
    global: global_commands_namespaceObject,
    instantAnswers: {},
    qa: {},
    reviewsList: {},
    reviewsSummary: {},
    spectrum: {},
    topComments: {},
    userToolbar: {},
    vcPinboard: {}
};
// Function that the command object is assigned to when initialized
function queueAndRunCommands() {
    queue.push(arguments);
    runCommands();
}
// Run any commands that are in the queue
function runCommands() {
    if (!isProcessingQueue) {
        isProcessingQueue = true;
        while (queue.length) {
            // removes the first item from the queue and converts the Arguments object to an array
            var args = Array.prototype.slice.call(queue.shift());
            // called without args
            if (args.length === 0) {
                logger["a" /* default */].error('TurnToCmd called without any arguments');
                continue;
            }
            // If the command contains a dot, then it's a specific widget command.
            // If no dot, it should be a global command.
            var cmd = args[0];
            var libraryName = 'global';
            var fnName = cmd;
            if (~cmd.indexOf('.')) {
                var cmdParts = cmd.split('.');
                libraryName = cmdParts[0];
                fnName = cmdParts[1];
            }
            var fn = widgetLibraries[libraryName] ? widgetLibraries[libraryName][fnName] : undefined;
            if (!isFunction(fn)) {
                logger["a" /* default */].error("\"" + cmd + "\" is not a valid command.");
                continue;
            }
            // finally verified, we can call the function.  Doesn't mean it won't fail if the arguments
            // for the function are incorrect
            var functionArgs = args.length > 1 ? args.slice(1) : [];
            fn.apply(null, functionArgs);
        }
        isProcessingQueue = false;
    }
}
function isFunction(fn) {
    return typeof fn === 'function';
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/util/dom-utils.ts
var dom_utils = __webpack_require__(2);

// CONCATENATED MODULE: ./src/mixins/modal-tab-control-mixin.ts
/**
 * This mixin is meant to be used by modal and popover components.
 * It keeps the tabbing within the modal/popover until the user exits
 * the popover/modal.
 * The top element in the component should have a tab event that calls
 * handleTab: @keydown.tab="handleTab"
 * It is the responsibility of the component inside the modal to set the first element to focus on.
 */

/* harmony default export */ var modal_tab_control_mixin = ({
    methods: {
        getFirstTabbableElement: function (tabbableElements) {
            var firstElement = tabbableElements[0];
            if (firstElement.type === 'radio') {
                firstElement = this.getTabToRadioBtn(firstElement.name, true);
            }
            return firstElement;
        },
        getLastTabbableElement: function (tabbableElements) {
            var lastElement = tabbableElements[tabbableElements.length - 1];
            if (lastElement.type === 'radio') {
                lastElement = this.getTabToRadioBtn(lastElement.name, false);
            }
            return lastElement;
        },
        getTabToRadioBtn: function (radioGroupName, forward) {
            var radioBtns = this.$el.querySelectorAll("[name=" + radioGroupName + "]");
            // if one is checked, that trumps all
            for (var i = 0; i < radioBtns.length; i++) {
                if (radioBtns[i].checked) {
                    return radioBtns[i];
                }
            }
            // if tabbing forward, it's the first button we select, if backwards its the last
            return forward ? radioBtns[0] : radioBtns[radioBtns.length - 1];
        },
        isFirstTabbableElement: function (elem, tabbableElements) {
            return elem === tabbableElements[0] || (elem.type === 'radio' &&
                tabbableElements[0].type === 'radio' && elem.name === tabbableElements[0].name);
        },
        isLastTabbableElement: function (elem, tabbableElements) {
            var trueLast = tabbableElements[tabbableElements.length - 1];
            return elem === trueLast || (elem.type === 'radio' && trueLast.type === 'radio' &&
                elem.name === trueLast.name);
        },
        handleTab: function (e) {
            var tabbableElements = dom_utils["a" /* default */].getTabbableElements(this.$el);
            if (e.shiftKey && this.isFirstTabbableElement(e.target, tabbableElements)) {
                // is on the first element, since this is shift+tab, need to now focus on last element
                e.preventDefault();
                this.getLastTabbableElement(tabbableElements).focus();
            }
            else if (!e.shiftKey && this.isLastTabbableElement(e.target, tabbableElements)) {
                e.preventDefault();
                this.getFirstTabbableElement(tabbableElements).focus();
            }
        }
    }
});

// EXTERNAL MODULE: ./src/services/msg.ts
var msg = __webpack_require__(4);

// EXTERNAL MODULE: ./src/util/browser-utils.ts
var browser_utils = __webpack_require__(16);

// CONCATENATED MODULE: ./src/util/body-scroll-lock.ts
// This ism eant for use by the modal.  Can only be applied to one element on the page.
// Helps hold the underlying page in position, while allowing the modal to scroll smoothly.
// Most of this code is due to the odd behavior of iOS.
//
// This is a trimmed down version of https://github.com/willmcpo/body-scroll-lock
// Notes from that library:
// Adopted and modified solution from Bohdan Didukh (2017)
// tslint:disable-next-line:max-line-length
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var targetElement;
var scrollY;
var initialClientY = -1;
var previousBodyOverflowSetting;
function allowMove(e) {
    return e.target && e.target.className.indexOf('tt-scoll-lock-ignore') > -1;
}
var preventDefault = function (rawEvent) {
    var e = rawEvent || window.event;
    if (allowMove(e)) {
        return true;
    }
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch
    // gesture like pinch to zoom)
    if (e.touches.length > 1)
        return true;
    if (e.preventDefault)
        e.preventDefault();
    return false;
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function (targetElement) {
    return targetElement ?
        targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight
        : false;
};
var handleScroll = function (e, targetElement) {
    var clientY = e.targetTouches[0].clientY - initialClientY;
    if (allowMove(e)) {
        return true;
    }
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll
        return preventDefault(e);
    }
    if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
        // element is at the top of its scroll
        return preventDefault(e);
    }
    e.stopPropagation();
    return true;
};
var disableBodyScroll = function (el) {
    // already disabled by something else
    if (targetElement) {
        return;
    }
    targetElement = el;
    if (browser_utils["h" /* isIOS */]) {
        targetElement.style['-webkit-overflow-scrolling'] = 'touch';
        targetElement.ontouchstart = function (e) {
            if (e.targetTouches.length === 1) {
                // detect single touch
                initialClientY = e.targetTouches[0].clientY;
            }
        };
        targetElement.ontouchmove = function (e) {
            if (e.targetTouches.length === 1) {
                // detect single touch
                handleScroll(e, targetElement);
            }
        };
        document.addEventListener('touchmove', preventDefault);
    }
    else {
        // Setting overflow on body/documentElement synchronously in Desktop Safari slows down
        // the responsiveness for some reason. Setting within a setTimeout fixes this.
        setTimeout(function () {
            // TT-11611 - form scrolling fix
            if (browser_utils["e" /* isAndroid */]) {
                scrollY = window.scrollY;
                window.scrollTo(window.scrollX, 0);
            }
            // If previousBodyOverflowSetting is already set, don't set it again.
            if (previousBodyOverflowSetting === undefined) {
                previousBodyOverflowSetting = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
            }
        });
    }
};
var enableBodyScroll = function () {
    if (browser_utils["h" /* isIOS */]) {
        if (targetElement) {
            targetElement.ontouchstart = null;
            targetElement.ontouchmove = null;
        }
        document.removeEventListener('touchmove', preventDefault);
    }
    else {
        // Setting overflow on body/documentElement synchronously in Desktop Safari slows down
        // the responsiveness for some reason. Setting within a setTimeout fixes this.
        setTimeout(function () {
            if (browser_utils["e" /* isAndroid */] && scrollY) {
                window.scrollTo(window.scrollX, scrollY);
            }
            if (previousBodyOverflowSetting !== undefined) {
                document.body.style.overflow = previousBodyOverflowSetting;
                // Restore previousBodyOverflowSetting to undefined
                // so setOverflowHidden knows it can be set again.
                previousBodyOverflowSetting = undefined;
            }
        });
    }
    targetElement = undefined;
};

// EXTERNAL MODULE: ./src/objects/popover/popover.ts
var popover = __webpack_require__(19);

// EXTERNAL MODULE: ./src/objects/modal/modal.html
var modal = __webpack_require__(31);
var modal_default = /*#__PURE__*/__webpack_require__.n(modal);

// EXTERNAL MODULE: ./src/objects/modal/modal.scss
var modal_modal = __webpack_require__(32);
var modal_modal_default = /*#__PURE__*/__webpack_require__.n(modal_modal);

// CONCATENATED MODULE: ./src/objects/modal/modal.ts








// NOTE: MUST USE v-if TO SHOW/HIDE THE MODAL. This is due to logic that adds an overflow style to
// the body of the page and removes that same style before the component is destroyed.
/* harmony default export */ var objects_modal_modal = __webpack_exports__["a"] = (modal_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () { return { scrollPosition: 0 }; },
    mixins: [modal_tab_control_mixin],
    props: {
        ariaLabel: String,
        ariaLabeledById: String,
        centered: {
            type: Boolean,
            default: false
        },
        closeLabel: {
            type: String,
            // had to import msg as this.$msg does not work here
            default: function () { return Object(msg["a" /* default */])('modal.close'); }
        },
        ariaDescribedById: String,
        // whether or not this modal is inside yet another modal. Important to set to true so
        // that the overflow set on body is not removed when the child modal is closed
        isLoading: Boolean,
        notifyOutsideClick: Boolean,
        popoverMessage: String,
        popoverType: {
            type: String,
            default: 'success'
        },
        showClose: {
            type: Boolean,
            default: true
        }
    },
    provide: {
        // this is made available for all child components to know whether they are inside of a modal
        // or not.  This is used by this modal as well as menu-list so they know how to close when not
        // directly in the body
        isInModal: true
    },
    inject: {
        // This is set by the "provide" above if this modal is inside another modal.  Otherwise, false
        isInModal: { default: false }
    },
    components: { 'tt-popover': popover["a" /* default */] },
    methods: {
        close: function () {
            this.$emit('close');
        },
        closePopover: function () {
            this.$emit('closePopover');
        },
        handleClick: function (e) {
            // if clicking outside of the container, then close it
            if (!this.$refs.container.contains(e.target) && !this.isExternalButtonClick(e) &&
                !this.isPopoverClick(e)) {
                this.notifyOutsideClick ? this.$emit('outsideClick') : this.close();
            }
        },
        isExternalButtonClick: function (e) {
            var externalBtns = this.$slots.externalButtons;
            if (externalBtns) {
                for (var i = 0; i < externalBtns.length; i++) {
                    var elem = externalBtns[i].elm;
                    if (elem && elem.nodeType === 1 && elem.contains(e.target)) {
                        return true;
                    }
                }
            }
            return false;
        },
        isPopoverClick: function (e) {
            var popover = this.$refs.popover;
            return popover && popover.$el.contains(e.target);
        }
    },
    created: function () {
        if (!this.ariaLabel && !this.ariaLabeledById && "production" === 'development') {
            // tslint:disable:next-line no-console
            console.error('Must provide ariaLabel or ariaLabeledById');
        }
    },
    mounted: function () {
        // prevent scrollbars from showing up for underlying body and allow for smooth scrolling on iOS
        if (!this.isInModal) {
            disableBodyScroll(this.$el);
        }
        // from modalTabControlMixin
        this.$el.focus();
    },
    beforeDestroy: function () {
        // re-enable body scrolling that was disabled when the modal was opened
        if (!this.isInModal) {
            enableBodyScroll();
        }
    },
    watch: {
        popoverMessage: function () {
            var _this = this;
            if (this.popoverMessage) {
                dom_utils["a" /* default */].whenRefIsVisible(this.$refs, 'popover').then(function () {
                    _this.$refs.popover.$el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
                });
            }
        }
    }
})));


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover_html__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__popover_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popover_scss__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popover_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__popover_scss__);



var TYPES = ['success', 'error'];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__popover_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        ariaLabel: String,
        asAlertDialog: Boolean,
        autoClose: Boolean,
        closeLabel: String,
        // specify message or provide slot
        message: String,
        showClose: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'success',
            validator: function (v) { return TYPES.indexOf(v) > -1; }
        }
    },
    computed: {
        iconName: function () {
            return this.type === 'error' ? 'error' : 'check';
        },
        typeClass: function () {
            return this.type ? "tt-o-popover--" + this.type : '';
        },
        role: function () {
            return this.asAlertDialog ? 'alertdialog' : 'alert';
        }
    },
    methods: {
        close: function () {
            this.$emit('close');
        }
    },
    created: function () {
        if (this.asAlertDialog && !this.ariaLabel && "production" === 'development') {
            // tslint:disable:next-line no-console
            console.error('Must provide ariaLabel');
        }
    },
    mounted: function () {
        var _this = this;
        if (this.autoClose) {
            // will close after a period of time.  Must use a v-if on the popover for mounted to be
            // called each time it is shown.
            setTimeout(function () {
                _this.close();
            }, (this.type === 'error' ? 10000 : 6000));
        }
    }
})));


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ORIGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CDN_URL; });
/* harmony export (immutable) */ __webpack_exports__["c"] = executeRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = executeStaticRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_ts_utils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_config__ = __webpack_require__(3);


var ORIGIN_URL = __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].originHost + "/v5";
var CDN_URL = __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].cdnHost + "/v5";
function createRequest(method, url, options, resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.addEventListener('load', function () {
        if (xhr.responseText) {
            // assume json
            try {
                xhr.data = JSON.parse(xhr.responseText);
            }
            catch (e) {
                xhr.data = {};
                reject(xhr);
                return;
            }
        }
        resolve(xhr);
    });
    var onError = function () {
        if (xhr.responseText) {
            // assume json
            try {
                xhr.data = JSON.parse(xhr.responseText);
            }
            catch (e) {
                xhr.data = {};
            }
        }
        reject(xhr);
    };
    xhr.addEventListener('error', onError);
    xhr.addEventListener('abort', onError);
    var params = options.params || {};
    // open needs to be called before setting content-type header for IE10-11
    xhr.open(method, url + "?" + Object(__WEBPACK_IMPORTED_MODULE_0_util_ts_utils__["c" /* buildQryString */])(params));
    var headers = options.headers;
    if (headers) {
        Object.keys(headers).forEach(function (h) { return xhr.setRequestHeader(h, headers[h]); });
    }
    // when true, allow CORS to send cookies
    xhr.withCredentials = options.withCredentials || false;
    return xhr;
}
function executeRequest(method, uri, options) {
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve, reject) {
        options.params = options.params || {};
        // set locale on all calls that doesn't already have that value in the path.
        if (!options.params.locale && uri.indexOf("" + __WEBPACK_IMPORTED_MODULE_1_init_config__["b" /* turnToConfig */].locale) === -1) {
            options.params.locale = __WEBPACK_IMPORTED_MODULE_1_init_config__["b" /* turnToConfig */].locale;
        }
        var url = "" + ORIGIN_URL + uri;
        if (!options.headers) {
            options.headers = {};
        }
        // all but static (CDN) calls need to have this header for CORS allow origin
        options.headers['X-Turnto-Sitekey'] = __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].siteKey;
        if (options.body && !options.headers['Content-Type']) {
            options.headers['Content-Type'] = 'application/json';
        }
        else if (options.formData && options.headers['Content-Type']) {
            // making sure to let xhr/formData set Content-Type. Needed for multi-part boundary
            delete options.headers['Content-Type'];
        }
        var xhr = createRequest(method, url, options, resolve, reject);
        // if a callback is provided for file upload progress
        if (options.progressCallback && xhr.upload) {
            xhr.upload.addEventListener('progress', options.progressCallback, false);
        }
        if (options.body) {
            xhr.send(JSON.stringify(options.body));
        }
        else if (options.formData) {
            xhr.send(options.formData);
        }
        else {
            xhr.send();
        }
    });
}
function executeStaticRequest(uri, options) {
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve, reject) {
        var url = "" + CDN_URL + uri;
        var xhr = createRequest('GET', url, options, resolve, reject);
        xhr.send();
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = createAndMountInstance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_logger__ = __webpack_require__(13);



function createAndMountInstance(existingInstance, widget, divId) {
    return new Promise(function (resolve) {
        if (existingInstance) {
            existingInstance.$destroy();
        }
        // if the dom element already exists, no need to wait for dom ready
        if (document.getElementById(divId)) {
            resolve(createInstance(widget, divId));
            return;
        }
        __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].onDomReady().then(function () {
            if (document.getElementById(divId)) {
                resolve(createInstance(widget, divId));
                return;
            }
            resolve();
            __WEBPACK_IMPORTED_MODULE_2_util_logger__["a" /* default */].warn("Widget not loaded at dom ready. Could not find div with id " + divId + ".");
        });
    });
}
function createInstance(widget, divId) {
    return new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
        el: "#" + divId,
        render: function (h) { return h(widget, {
            attrs: { id: divId }
        }); }
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = truncateText;
/**
 * Truncates the provided text given the truncateLength and truncateAllowance.
 * If the text does not need to be truncated, null string is returned
 * TODO: does this work for Chinese? Do we bother with Arabic?
 *
 * @param text - text to truncate (should already be trimmed, otherwise spaces count)
 * @param truncateLength - how long the truncated text should be
 * @param truncateAllowance - allows the text to go over a little without truncation. Helps avoid
 *                            a case where the expanded text is only a few more characters.
 */
function truncateText(text, truncateLength, truncateAllowance) {
    if (truncateAllowance === void 0) { truncateAllowance = 0; }
    var shouldTruncate = text && text.length > (truncateLength + truncateAllowance);
    if (shouldTruncate) {
        // doing +1 to determine if last character is the end of a word or not
        var truncatedTextPlus1 = text.substring(0, truncateLength + 1);
        var lastSpaceIndex = truncatedTextPlus1.lastIndexOf(' ');
        if (lastSpaceIndex < 0) {
            // need to do a hard truncate because there is no space
            return text.substring(0, truncateLength + truncateAllowance);
        }
        if (lastSpaceIndex === truncatedTextPlus1.length - 1) {
            // last character is a space, just trim
            return truncatedTextPlus1.trim();
        }
        return text.substring(0, lastSpaceIndex).trim();
    }
    return null;
}


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        catItem: {
            type: Object,
            required: true
        },
        includeAlt: {
            type: Boolean,
            default: true
        },
        isLinkable: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'L'
        },
        siblingSiteKey: { type: String }
    },
    computed: {
        imageUrl: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__["e" /* getProductImageUrl */])(this.catItem, this.size, this.siblingSiteKey);
        }
    },
    render: function (h) {
        // Ugly using render instead of a normal <template>, but we don't have a difinitive root
        // element for the <template>, which Vue requires.  If linkable, then the root is <a>,
        // otherwise, the root is <img>
        // A way around this would be to wrap in a div, which product image usually is, would
        // just need to be able to apply the necessary classes.
        var img = h('img', {
            attrs: {
                src: this.imageUrl,
                alt: this.includeAlt ? this.catItem.title : '',
                class: 'tt-o-product__image'
            }
        });
        if (!this.isLinkable) {
            return img;
        }
        return h('a', {
            attrs: {
                href: this.catItem.url,
                target: '_blank',
                rel: 'nofollow',
                class: 'tt-o-product__image-link'
            }
        }, [img]);
    }
}));


/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_html__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_scss__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__header_scss__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__header_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        description: String,
        heading: String,
        withBorder: {
            type: Boolean,
            default: true
        }
    }
})));


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rating_stars_html__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rating_stars_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__rating_stars_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rating_stars_scss__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rating_stars_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__rating_stars_scss__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__rating_stars_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () { return {}; },
    props: {
        // text that is hidden from view, but accessible to screen readers.  Case where NOT to include
        // is reviews summary, where the info is redundant
        includeAccessibleText: {
            type: Boolean,
            default: true
        },
        rating: {
            type: Number,
            default: 0
        },
        starSize: {
            type: String,
            default: 'md'
        }
    },
    computed: {
        adjustedRating: function () {
            var floorValue = Math.floor(this.rating);
            var rounded = Math.round(this.rating * 100) / 100;
            var decimalValue = parseFloat((rounded - floorValue).toFixed(2));
            if (decimalValue < 0.25) {
                return floorValue;
            }
            else if (decimalValue < 0.75) {
                return floorValue + 0.5;
            }
            return floorValue + 1;
        }
    },
    methods: {
        starIcon: function (starNum) {
            if (starNum > this.adjustedRating && starNum - this.adjustedRating >= 1) {
                return 'star--empty';
            }
            else if (starNum <= this.adjustedRating) {
                return 'star--full';
            }
            return 'star--half';
        }
    }
})));


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_objects_header_header__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_objects_modal_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__warn_close_modal_html__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__warn_close_modal_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__warn_close_modal_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__warn_close_modal_scss__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__warn_close_modal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__warn_close_modal_scss__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__warn_close_modal_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    name: 'WarnCloseModal',
    components: {
        'tt-header': __WEBPACK_IMPORTED_MODULE_1_objects_header_header__["a" /* default */],
        'tt-modal': __WEBPACK_IMPORTED_MODULE_2_objects_modal_modal__["a" /* default */]
    },
    methods: {
        close: function () {
            this.$emit('close');
        },
        closeParentModal: function () {
            this.$emit('closeParentModal');
        }
    },
    mounted: function () {
        var _this = this;
        this.$nextTick(function () { return _this.$refs.returnBtn.$el.focus(); });
    }
})));


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widgets_standalone_popover_standalone_popover_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_objects_modal_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_warn_close_modal_warn_close_modal__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__submission_modal_html__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__submission_modal_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__submission_modal_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__submission_modal_scss__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__submission_modal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__submission_modal_scss__);







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__submission_modal_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    name: 'SubmissionModal',
    data: function () {
        return {
            isConfirmOpen: false,
            isFormLoaded: false,
            popoverMessage: '',
            popoverType: '',
            preventClickOutside: false,
            submissionStore: __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */]
        };
    },
    components: {
        'tt-modal': __WEBPACK_IMPORTED_MODULE_3_objects_modal_modal__["a" /* default */],
        // tslint:disable-next-line
        'tt-submission-mediator': function () { return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 63)); },
        'tt-warn-close-modal': __WEBPACK_IMPORTED_MODULE_4_components_warn_close_modal_warn_close_modal__["a" /* default */]
    },
    computed: {
        isOpen: function () {
            return this.submissionStore.isOpen;
        },
        poweredByText: function () {
            return this.submissionStore.poweredByText;
        }
    },
    methods: {
        closeConfirm: function () {
            var _this = this;
            this.isConfirmOpen = false;
            this.$nextTick(function () { return _this.$el.focus(); });
        },
        closePopover: function () {
            this.popoverMessage = '';
        },
        closeSubmissionModal: function () {
            this.isConfirmOpen = false;
            __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].fireBackEvent();
        },
        pageLoaded: function (preventClickOutside) {
            if (preventClickOutside === void 0) { preventClickOutside = false; }
            this.isFormLoaded = true;
            this.preventClickOutside = preventClickOutside;
        },
        pageLoading: function () {
            this.isFormLoaded = false;
        },
        onShowError: function (providedMessage, closeModal, autoClosePopup) {
            if (closeModal === void 0) { closeModal = false; }
            if (autoClosePopup === void 0) { autoClosePopup = true; }
            if (closeModal) {
                var message = providedMessage || this.$msg('flowError.2000');
                __WEBPACK_IMPORTED_MODULE_2_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({ message: message, type: 'error', autoClose: autoClosePopup });
                this.closeSubmissionModal();
                return;
            }
            this.popoverMessage = providedMessage;
            this.popoverType = 'error';
        },
        onShowPopoverMessage: function (message, closeModal) {
            if (closeModal === void 0) { closeModal = false; }
            if (closeModal) {
                __WEBPACK_IMPORTED_MODULE_2_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({ message: message });
                this.closeSubmissionModal();
                return;
            }
            this.popoverMessage = message;
            this.popoverType = 'success';
        },
        outsideClick: function () {
            if (this.preventClickOutside) {
                this.isConfirmOpen = true;
                return;
            }
            this.closeSubmissionModal();
        }
    }
})));


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "tt-o-popover-" } }, [
    _c(
      "div",
      {
        staticClass: "tt-o-popover",
        class: _vm.typeClass,
        attrs: {
          role: _vm.role,
          "aria-label": _vm.ariaLabel,
          "aria-modal": "false",
          tabindex: "-1",
          "aria-live": "polite"
        },
        on: {
          keydown: function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
            ) {
              return null
            }
            $event.stopPropagation()
            return _vm.close($event)
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "tt-o-popover__icon" },
          [_c("tt-icon", { attrs: { name: _vm.iconName, size: "sm" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tt-o-popover__body" },
          [
            _vm.message
              ? _c("p", {
                  staticClass: "tt-o-popover__text",
                  domProps: { innerHTML: _vm._s(_vm.message) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        ),
        _vm._v(" "),
        _vm.showClose
          ? _c(
              "div",
              { staticClass: "tt-o-popover__close" },
              [
                _c(
                  "tt-button",
                  {
                    ref: "closeBtn",
                    staticClass: "tt-o-popover__close-btn",
                    attrs: {
                      type: "icon",
                      "aria-label": _vm.closeLabel,
                      title: _vm.closeLabel
                    },
                    on: { click: _vm.close }
                  },
                  [_c("tt-icon", { attrs: { name: "close", size: "xxs" } })],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("534a7da4", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("534a7da4", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        staticClass: "tt-o-modal",
        class: { "tt-o-modal--centered": _vm.centered },
        attrs: {
          role: "dialog",
          "aria-label": _vm.ariaLabel,
          "aria-labelledby": _vm.ariaLabeledById,
          "aria-describedby": _vm.ariaDescribedById,
          "aria-modal": "true",
          tabindex: "-1"
        },
        on: {
          keydown: [
            function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
              ) {
                return null
              }
              $event.stopPropagation()
              return _vm.handleTab($event)
            },
            function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
              ) {
                return null
              }
              $event.stopPropagation()
              return _vm.close($event)
            }
          ],
          click: function($event) {
            $event.stopPropagation()
            _vm.handleClick($event)
          }
        }
      },
      _vm.$listeners
    ),
    [
      _vm.popoverMessage
        ? _c("tt-popover", {
            ref: "popover",
            staticClass: "tt-o-modal__popover",
            attrs: {
              autoClose: true,
              message: _vm.popoverMessage,
              type: _vm.popoverType
            },
            on: { close: _vm.closePopover }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "container", staticClass: "tt-o-modal__container" }, [
        _vm.showClose
          ? _c(
              "div",
              { staticClass: "tt-o-modal__close" },
              [
                _c(
                  "tt-button",
                  {
                    ref: "closeBtn",
                    staticClass: "tt-o-modal__close-btn",
                    attrs: {
                      type: "icon",
                      "aria-label": _vm.closeLabel,
                      title: _vm.closeLabel
                    },
                    on: { click: _vm.close }
                  },
                  [_c("tt-icon", { attrs: { name: "close", size: "xs" } })],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tt-o-modal__body" },
          [
            _vm.isLoading
              ? _c("div", { staticClass: "tt-o-modal__loading" }, [
                  _c("div", { staticClass: "tt-o-spinner" })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm._t("externalButtons"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-o-modal__poweredby-footer" },
        [_vm._t("poweredByText")],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("5057139e", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("5057139e", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tt-o-header",
      class: { "tt-o-header--with-border": _vm.withBorder }
    },
    [
      _c("div", {
        staticClass: "tt-o-header__heading",
        attrs: { role: "heading" },
        domProps: { innerHTML: _vm._s(_vm.heading) }
      }),
      _vm._v(" "),
      _vm.description
        ? _c("p", {
            staticClass: "tt-o-header__text",
            domProps: { innerHTML: _vm._s(_vm.description) }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("721f269a", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("721f269a", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tt-modal",
    {
      staticClass: "tt-c-warn-close-modal",
      attrs: {
        ariaLabel: _vm.$msg("warnCloseModal.label"),
        centered: true,
        showClose: false
      },
      on: { close: _vm.close }
    },
    [
      _c("tt-header", {
        staticClass: "tt-c-warn-close-modal__header",
        attrs: { heading: _vm.$msg("warnCloseModal.title") }
      }),
      _vm._v(" "),
      _c("p", {
        staticClass: "tt-c-warn-close-modal__message",
        domProps: { innerHTML: _vm._s(_vm.$msg("warnCloseModal.message")) }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-c-warn-close-modal__actions tt-o-button-group" },
        [
          _c("tt-button", {
            ref: "returnBtn",
            staticClass: "tt-c-warn-close-modal__return",
            attrs: { type: "primary" },
            domProps: { innerHTML: _vm._s(_vm.$msg("warnCloseModal.return")) },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.close($event)
              }
            }
          }),
          _vm._v(" "),
          _c("tt-button", {
            staticClass: "tt-c-warn-close-modal__leave",
            attrs: { type: "secondary" },
            domProps: { innerHTML: _vm._s(_vm.$msg("warnCloseModal.leave")) },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.closeParentModal($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("3ca8798e", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("3ca8798e", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c(
        "tt-modal",
        {
          staticClass: "tt-w-submission-modal",
          attrs: {
            ariaLabel: _vm.$msg("submission.title"),
            closeLabel: _vm.$msg("submission.close"),
            isLoading: !_vm.isFormLoaded,
            popoverMessage: _vm.popoverMessage,
            popoverType: _vm.popoverType,
            notifyOutsideClick: true
          },
          on: {
            showError: _vm.onShowError,
            close: _vm.closeSubmissionModal,
            closePopover: _vm.closePopover,
            outsideClick: _vm.outsideClick
          }
        },
        [
          _c("tt-submission-mediator", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isFormLoaded,
                expression: "isFormLoaded"
              }
            ],
            on: {
              pageLoading: _vm.pageLoading,
              pageLoaded: _vm.pageLoaded,
              showPopoverMessage: _vm.onShowPopoverMessage,
              showError: _vm.onShowError
            }
          }),
          _vm._v(" "),
          _vm.isConfirmOpen
            ? _c("tt-warn-close-modal", {
                on: {
                  close: _vm.closeConfirm,
                  closeParentModal: _vm.closeSubmissionModal
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", {
            attrs: { slot: "poweredByText" },
            domProps: { innerHTML: _vm._s(_vm.poweredByText) },
            slot: "poweredByText"
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("4a45375f", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("4a45375f", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkTurntoflow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_dom_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_msg__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_ts_utils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_turnto_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__confirmation_message_flows__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__review_flows__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__qa_flows__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__seller_rating_flows__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_token_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widgets_standalone_popover_standalone_popover_loader__ = __webpack_require__(12);




 // dp
 // dp
 // dp
 // dp


// This checks to see if the user reloaded the page.  The interpretation of "reload" is different
// depending on the browser. All will treat the reload/refresh icon click as a realod as well as
// the key command for reload.  What is treated differently is the user clicking in the address
// bar and hitting the enter key.  Chrome treats it as a reload, but most other browsers do not.
function isReload() {
    // for old iOS 7.  Can't support because window.performance is not present.
    if (!window.performance) {
        return false;
    }
    if (typeof window.performance['getEntriesByType'] === 'function') {
        // pnt - PerformanceNavigationTiming interface
        var pnt = Object(__WEBPACK_IMPORTED_MODULE_2_util_ts_utils__["a" /* arrayFind */])(window.performance.getEntriesByType('navigation'), function (entry) { return entry.type; });
        if (pnt) {
            return pnt.type !== 'navigate';
        }
    }
    // for the case where the PerformanceNavigationTiming interface is not present, try the
    // deprecated PerformanceNavigation interface
    var pn = window.performance['navigation'];
    return !pn || pn.type === undefined ? false : pn.type !== 0;
}
function checkTurntoflow() {
    var params = Object(__WEBPACK_IMPORTED_MODULE_2_util_ts_utils__["e" /* getParameters */])();
    var turntoflow = null;
    if (params.turntoflow) {
        turntoflow = params.turntoflow;
        if (isReload()) {
            return;
        }
        var ttdat = params[__WEBPACK_IMPORTED_MODULE_3_util_turnto_utils__["b" /* TTDAT_PARAM_NAME */]];
        // if confirmation token is passed, login the user
        if (params.tttok && ttdat) {
            Object(__WEBPACK_IMPORTED_MODULE_8_services_token_service__["c" /* loginUser */])(params.tttok, ttdat);
        }
        __WEBPACK_IMPORTED_MODULE_0_util_dom_utils__["a" /* default */].onDomReady().then(function () {
            if (params.tterr && params.tterr !== '1101') {
                __WEBPACK_IMPORTED_MODULE_9_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({
                    message: Object(__WEBPACK_IMPORTED_MODULE_1_services_msg__["a" /* default */])("flowError." + params.tterr),
                    type: 'error'
                });
                // no need to proceed to any other flows
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_4__confirmation_message_flows__["a" /* checkForFlow */])(turntoflow, params); // dp
            Object(__WEBPACK_IMPORTED_MODULE_5__review_flows__["a" /* checkForFlow */])(turntoflow, params); // dp
            Object(__WEBPACK_IMPORTED_MODULE_6__qa_flows__["a" /* checkForFlow */])(turntoflow, params); // dp
            Object(__WEBPACK_IMPORTED_MODULE_7__seller_rating_flows__["a" /* checkForFlow */])(turntoflow, params); // dp
        });
    }
}


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = checkForFlow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_global_config__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widgets_submission_submission_loader__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_submission_store__ = __webpack_require__(7);



var FLOW_DATA = {
    qco: { rf: 'question', rq: 'optional' },
    qcr: { rf: 'question', rq: 'required' },
    aco: { rf: 'answer', rq: 'optional' },
    acr: { rf: 'answer', rq: 'required' },
    repco: { rf: 'reply', rq: 'optional' },
    repcr: { rf: 'reply', rq: 'required' },
    revco: { rf: 'review', rq: 'optional' },
    revcr: { rf: 'review', rq: 'required' }
};
var CONFIRMATION_FLOW_KEYS = Object.keys(FLOW_DATA);
/**
 * These flows are confirmation message flows.  In other words, there is no action to be taken,
 * only display a popover message to the user.
 *
 * @param flow
 * @param params
 * @param data
 */
function checkForFlow(flow, params) {
    return new Promise(function (resolve) {
        if (CONFIRMATION_FLOW_KEYS.indexOf(flow) > -1) {
            if (params.tterr === '1101') {
                // expired confirmation token
                // tslint:disable-next-line
                __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 64)).then(function (expiredConfirmationLoader) {
                    expiredConfirmationLoader.default.load({
                        registerFor: FLOW_DATA[flow].rf,
                        registrationQualifier: FLOW_DATA[flow].rq,
                        token: params.ttrtok
                    });
                });
                resolve(true);
                return;
            }
            // open Do More with appropriate message
            var messageType = FLOW_DATA[flow].rf;
            if (messageType === 'question' && __WEBPACK_IMPORTED_MODULE_0_init_global_config__["a" /* default */].isAllowAnon()) {
                messageType = 'questionAnon';
            }
            __WEBPACK_IMPORTED_MODULE_2_store_submission_store__["b" /* default */].currentPage = {
                page: 'do-more',
                props: { msgType: messageType }
            };
            __WEBPACK_IMPORTED_MODULE_1_widgets_submission_submission_loader__["a" /* default */].load();
            resolve(true);
        }
        else {
            resolve(false);
        }
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = checkForFlow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_service__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_init_global_config__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_init_global_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_logger__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_token_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_msg__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_sso_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widgets_standalone_popover_standalone_popover_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widgets_submission_submission_loader__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_ts_utils__ = __webpack_require__(8);













function checkForFlow(flow, params) {
    return new Promise(function (resolve) {
        if (!isReviewFlow(flow, params)) {
            resolve(false);
            return;
        }
        if (flow === 'optout') {
            __WEBPACK_IMPORTED_MODULE_9_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({
                message: Object(__WEBPACK_IMPORTED_MODULE_7_services_msg__["a" /* default */])('flowMsg.optout.rse')
            });
            resolve(true);
            return;
        }
        var page = 'review-form';
        var launchData = {};
        var props = {};
        if (flow === 'review') {
            launchData = getRseLaunchData(params);
            if (launchData.startAction === 'visual') {
                page = 'share-media';
            }
        }
        else if (flow === 'rebelmail') {
            launchData = getRebelmailLaunchData(params);
            if (launchData.reviewId) {
                page = 'do-more';
                props = { msgType: 'review' };
            }
            else if (launchData.alreadyReviewed) {
                page = 'do-more';
                props = { msgType: 'alreadyReviewed' };
            }
        }
        else if (flow === 'revpr') {
            // coming from a purchase required confirmation email and should already be logged in from
            // email-flow-entry. now place the user on the review page
            launchData.startAction = 'review';
        }
        // if we have a RSE token, need to remove currently logged in user (if any)
        if (launchData.rseToken) {
            Object(__WEBPACK_IMPORTED_MODULE_6_services_token_service__["d" /* logoutUser */])();
        }
        // for successful inbox submission flow, need to check for seller rating eligibility.  Since
        // need to make server call, needs to be async and wait before proceeding.
        // Ideally would do with await/async, but not available in all browsers, so we have this nested
        // promises situation
        checkSellerRatingEligibile(launchData, params).then(function (transactionId) {
            if (transactionId) {
                // because we are coming from an RSE, the token needs to be stored in review launch data
                // so the seller rating form knows which initData method to call
                __WEBPACK_IMPORTED_MODULE_10_store_submission_store__["b" /* default */].launchData = { rseToken: launchData.rseToken };
                __WEBPACK_IMPORTED_MODULE_10_store_submission_store__["b" /* default */].startSellerRatingFlow(__WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, { page: 'seller-rating-form', props: { msgType: 'reviewed' } }, { transactionId: transactionId });
                __WEBPACK_IMPORTED_MODULE_11_widgets_submission_submission_loader__["a" /* default */].load().then(function () { return resolve(true); });
                return;
            }
            startRevFlow(flow, launchData, params, { page: page, props: props }).then(function () { return resolve(true); });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_5_util_logger__["a" /* default */].error(e);
            startRevFlow(flow, launchData, params, { page: page, props: props }).then(function () { return resolve(true); });
        });
    });
}
function startRevFlow(flow, launchData, params, page) {
    return new Promise(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_12_util_ts_utils__["h" /* waitForValue */])(function () { return params.turntosku || __WEBPACK_IMPORTED_MODULE_4_init_global_store__["a" /* default */].sku; }).then(function (sku) {
            if (__WEBPACK_IMPORTED_MODULE_3_init_global_config__["a" /* default */].ssoEnabled && ['review', 'rebelmail', 'share-media'].indexOf(flow) > -1) {
                Object(__WEBPACK_IMPORTED_MODULE_8_services_sso_service__["h" /* ssoGetLoggedInData */])(sku, page, launchData, 'rev');
                resolve();
                return;
            }
            __WEBPACK_IMPORTED_MODULE_10_store_submission_store__["b" /* default */].startRevFlow(sku, __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, page, launchData);
            __WEBPACK_IMPORTED_MODULE_11_widgets_submission_submission_loader__["a" /* default */].load().then(function () { return resolve(); });
        });
    });
}
// if yes, then resolves with transaction id, otherwise resolves to no
function checkSellerRatingEligibile(launchData, params) {
    return new Promise(function (resolve, reject) {
        if (launchData.reviewId && params.turntoCheckSrEligibility === '1') {
            __WEBPACK_IMPORTED_MODULE_0_services_api_service__["a" /* default */].checkSellerRatingEligibile({ 'context-token': launchData.rseToken, lastSeenSrDate: Object(__WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__["d" /* getLastSeenSellerRatingDate */])() }).then(function (data) {
                resolve(data.transactionId);
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_5_util_logger__["a" /* default */].error(e);
                resolve(null);
            });
        }
        else {
            resolve(null);
        }
    });
}
function getRseLaunchData(params) {
    var launchData = {
        rseToken: params.tttok || params.token,
        source: __WEBPACK_IMPORTED_MODULE_10_store_submission_store__["a" /* Source */].RSE
    };
    if (params.reviewStartAction) {
        launchData.startAction = params.reviewStartAction === 'shareAPhoto' ? 'visual' : 'review';
    }
    if (params.starSelected) {
        launchData.starSelected = parseInt(params.starSelected) || 0;
        if (launchData.starSelected < 0 || launchData.starSelected > 5) {
            launchData.starSelected = 0;
        }
    }
    return launchData;
}
function getRebelmailLaunchData(params) {
    return {
        alreadyReviewed: params.turntotoAlreadyReviewed === '1',
        hasErrors: params.turntoReviewHasErrors ? true : false,
        showGuidelines: params.turntoShowGuidelines === '1' ? true : false,
        startAction: 'review',
        rseToken: params.tttok || params.token,
        reviewId: params.turntoReviewId ? parseInt(params.turntoReviewId) : null,
        source: __WEBPACK_IMPORTED_MODULE_10_store_submission_store__["a" /* Source */].RSE
    };
}
function isReviewFlow(flow, params) {
    // If flow is 'optout', need to make sure it's from an RSE. Could be from question email.
    return (flow === 'optout' && (params.turntoEmailType === 'reviewSolicitation' ||
        params.turntoEmailType === 'rseFollowUp')) ||
        ['review', 'rebelmail', 'revpr'].indexOf(flow) > -1;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = checkForFlow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_global_config__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_global_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_token_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_msg__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_sso_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_widgets_submission_submission_loader__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widgets_standalone_popover_standalone_popover_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_ts_utils__ = __webpack_require__(8);










function checkForFlow(flow, params) {
    return new Promise(function (resolve) {
        if (!isQaFlow(flow, params)) {
            resolve(false);
            return;
        }
        if (flow === 'irrelevantq' || flow === 'optout') {
            __WEBPACK_IMPORTED_MODULE_8_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({
                message: Object(__WEBPACK_IMPORTED_MODULE_4_services_msg__["a" /* default */])("flowMsg." + (flow === 'optout' ? flow + ".question" : flow))
            });
            resolve(true);
            return;
        }
        // All content solicitation cases should have a token. The "question approval email" sent to
        // moderators is posing as a content soliciation email with turntoflow=answerview (TT-11589).
        // This will skip it as it doesn't have a token.
        if (!params.tttok) {
            resolve(false);
            return;
        }
        var qaLaunchData = {};
        var page = 'solo-question';
        var props = {};
        qaLaunchData.emailToken = params.tttok;
        // coming from content solicitation email, need to remove currently logged in user (if any)
        Object(__WEBPACK_IMPORTED_MODULE_3_services_token_service__["d" /* logoutUser */])();
        if (flow === 'answer') {
            qaLaunchData.view = 'answer';
            qaLaunchData.answerText = params.ttAnswer;
            // itemQuestionRecipientLogId
            qaLaunchData.iqrlId = params.iqrlId ? parseInt(params.iqrlId) : null;
        }
        else if (flow === 'thankanswer') {
            qaLaunchData.view = 'replyToAnswer';
        }
        else if (flow === 'answerreply') {
            qaLaunchData.view = 'replyToReply';
        }
        else if (flow === 'answerview' || flow === 'replyview') {
            qaLaunchData.view = 'seeAll';
        }
        else if (flow === 'thanka') {
            page = 'do-more';
            props = { msgType: 'thank' };
        }
        Object(__WEBPACK_IMPORTED_MODULE_9_util_ts_utils__["h" /* waitForValue */])(function () { return params.turntosku || __WEBPACK_IMPORTED_MODULE_1_init_global_store__["a" /* default */].sku; }).then(function (sku) {
            if (__WEBPACK_IMPORTED_MODULE_0_init_global_config__["a" /* default */].ssoEnabled) {
                Object(__WEBPACK_IMPORTED_MODULE_5_services_sso_service__["h" /* ssoGetLoggedInData */])(sku, { page: page, props: props }, qaLaunchData, 'qa');
                resolve(true);
                return;
            }
            __WEBPACK_IMPORTED_MODULE_7_store_submission_store__["b" /* default */].startQaFlow(sku, __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, { page: page, props: props }, qaLaunchData);
            __WEBPACK_IMPORTED_MODULE_6_widgets_submission_submission_loader__["a" /* default */].load().then(function () { return resolve(true); });
        });
    });
}
function isQaFlow(flow, params) {
    // If flow is 'optout', need to make sure it is from a question email, not an RSE
    return (flow === 'optout' && params.turntoEmailType === 'question') ||
        [
            'answer',
            'irrelevantq',
            'thankanswer',
            'thanka',
            'answerview',
            'answerreply',
            'replyview' // clicking on "see all answers" from reply email
        ].indexOf(flow) > -1;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = checkForFlow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_global_config__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_sso_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_submission_store__ = __webpack_require__(7);





var SELLER_RATING_FLOW_KEYS = ['sellerrating'];
/**
 * These flows are seller rating flows.  Currently, there is only one flow.
 *
 * @param flow
 * @param params
 * @param data
 */
function checkForFlow(flow, params) {
    return new Promise(function (resolve) {
        if (SELLER_RATING_FLOW_KEYS.indexOf(flow) > -1) {
            var launchData = { emailToken: params.tttok || params.token };
            if (params.starSelected) {
                launchData.starSelected = parseInt(params.starSelected) || 0;
                if (launchData.starSelected < 0 || launchData.starSelected > 5) {
                    launchData.starSelected = undefined;
                }
            }
            var submissionPage = { page: 'seller-rating-form', props: {} };
            if (__WEBPACK_IMPORTED_MODULE_0_init_global_config__["a" /* default */].ssoEnabled) {
                // for soft-login
                Object(__WEBPACK_IMPORTED_MODULE_2_services_sso_service__["h" /* ssoGetLoggedInData */])(null, submissionPage, launchData, 'sr');
                resolve(true);
                return;
            }
            __WEBPACK_IMPORTED_MODULE_4_store_submission_store__["b" /* default */].startSellerRatingFlow(__WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].siteKey, submissionPage, launchData);
            __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__["a" /* default */].load();
            resolve(true);
        }
        else {
            resolve(false);
        }
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);

/**
 * A component that uses this mixin to be a tile in a masonry layout needs to do the following:
 * 1) When the component is loaded and height can be determined, set "this.isReady" to true
 * 2) When the tileWidth changes, "this.isReady" will be set back to false and needs to be set
 *    back to true when the tile is ready to be re-positioned.  In most cases this can be right
 *    away.  This can be accomplished by putting a "watch" on "tileWidth" and setting isReady
 *    at that time.  An exception is vc-pinboard where images need to calculate new heights and
 *    may take some time.
 * 3) If a single tile changes it's height, call this.tileExpanded(). This handles the case that
 *    exists on comments pinboard of chatter where a "read more" is clicked, causing the tile to
 *    grow in height.
 * 4) Inline styles will be applied to the component's root element to size and position it.
 *    If there are no other inline styles to be applied by the component itself, just put
 *      :style="tileStyles"
 *    on the root element of the component.  If there are other styles to add, use this.tileStyles()
 *    to get the styles needed for the layout and add whatever other styles are needed.
 * 5) The order of the tile (tileOrder) needs to be set as a prop when the component is used inside
 *    the layout. An example using the Comment component:
 *      <tt-comment v-for="(comment, index) in comments"
 *                  :tileOrder="index"
 *                  :key="comment.id">
 */
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return {
            // signifies if the tile is ready to be drawn or redrawn
            isReady: false,
            tileAttributes: {
                width: 0,
                opacity: 0,
                top: 0,
                left: 0
            }
        };
    },
    props: {
        tileOrder: {
            type: Number,
            default: 0
        }
    },
    computed: {
        isTile: function () {
            return this.tileWidth > 0;
        },
        tileStyles: function () {
            if (!this.isTile) {
                return {};
            }
            var styleProps = this.tileAttributes;
            return {
                width: this.tileWidth > 0 ? this.tileWidth + "px" : 0,
                opacity: styleProps.opacity,
                transform: "translateX(" + styleProps.left + "px) translateY(" + styleProps.top + "px)"
            };
        },
        tileWidth: function () {
            return this.tileAttributes.width;
        }
    },
    methods: {
        // called by layout.ts when the tileWidth has changed
        setWidth: function (width) {
            // setting "isReady" back to false so the tile can determine when it is ready to be
            // repositioned.
            this.isReady = false;
            this.tileAttributes.width = width;
        },
        tileHeightChanged: function () {
            // the slot (child) component changed height.
            // from here, fire event up to the layout to handle the height change
            this.$parent.$emit('tileHeightChanged', this);
        }
    }
}));


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getElapsedTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_msg__ = __webpack_require__(4);

var intervals = [
    { ms: 31536000, i: 'year' },
    { ms: 2592000, i: 'month' },
    { ms: 604800, i: 'week' },
    { ms: 86400, i: 'day' },
    { ms: 3600, i: 'hour' },
    { ms: 60, i: 'minute' }
];
function getElapsedTime(dateMillis) {
    if (!dateMillis) {
        return '';
    }
    var nowMillis = new Date().getTime();
    var diff = Math.floor((nowMillis - dateMillis) / 1000);
    var interval;
    var num = 0;
    for (var i = 0; i < intervals.length; i++) {
        if (diff >= intervals[i].ms) {
            interval = intervals[i].i;
            num = Math.floor(diff / intervals[i].ms);
            break;
        }
    }
    if (!interval) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_services_msg__["a" /* default */])('time.lessThanMinuteAgo');
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_services_msg__["a" /* default */])("time." + interval + "sAgo", [num], num);
}


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-rating" },
    [
      _vm.includeAccessibleText
        ? _c("div", {
            staticClass: "tt-u-clip-hide",
            domProps: {
              innerHTML: _vm._s(_vm.$msg("ratingStars.rating", [_vm.rating]))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(5, function(n) {
        return _c(
          "div",
          { key: n, staticClass: "tt-c-rating__star" },
          [
            _c("tt-icon", {
              staticClass: "tt-c-rating__icon",
              attrs: { name: _vm.starIcon(n), size: _vm.starSize }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("41260bfa", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("41260bfa", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openFacebookShare;
/* harmony export (immutable) */ __webpack_exports__["b"] = openPinterestShare;
/* harmony export (immutable) */ __webpack_exports__["c"] = openTwitterShare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_ts_utils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_http_client__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_config__ = __webpack_require__(3);



function getSocialRedirectUrl(socialUrl, socialUrlParamName, shareUrl) {
    var params = { socialUrl: socialUrl, socialUrlParamName: socialUrlParamName, shareUrl: shareUrl, siteKey: __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey };
    return __WEBPACK_IMPORTED_MODULE_1_services_http_client__["b" /* ORIGIN_URL */] + "/social/shortenUrlRedirect?" + Object(__WEBPACK_IMPORTED_MODULE_0_util_ts_utils__["c" /* buildQryString */])(params);
}
function openFacebookShare(shareUrl, quote) {
    if (quote === void 0) { quote = null; }
    // Facebook sharer only allows URL and some text to be passed
    var socialUrl = 'https://www.facebook.com/sharer/sharer.php';
    if (quote) {
        socialUrl = socialUrl + "?quote=" + quote;
    }
    Object(__WEBPACK_IMPORTED_MODULE_0_util_ts_utils__["g" /* openWindow */])(getSocialRedirectUrl(socialUrl, 'u', shareUrl));
}
function openPinterestShare(shareUrl, imageUrl, description) {
    var baseUrl = 'https://www.pinterest.com/pin/create/button';
    var queryStr = "media=" + imageUrl + "&description=" + description;
    Object(__WEBPACK_IMPORTED_MODULE_0_util_ts_utils__["g" /* openWindow */])(getSocialRedirectUrl(baseUrl + "?" + queryStr, 'url', shareUrl));
}
function openTwitterShare(shareUrl, text) {
    var socialUrl = 'https://twitter.com/intent/tweet';
    if (text) {
        socialUrl = socialUrl + "?text=" + text;
    }
    Object(__WEBPACK_IMPORTED_MODULE_0_util_ts_utils__["g" /* openWindow */])(getSocialRedirectUrl(socialUrl, 'url', shareUrl));
}


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/**
 * Place to store comments pinboard mutable state.
 * The `state` property within the store class contains the
 * actual data that changes.
 *
 * @see https://vuejs.org/v2/guide/state-management.html#Simple-State-Management-from-Scratch
 */
/**
 * The store class itself. An instance is created below and exported as
 * the default export.
 */
var Store = /** @class */ (function () {
    function Store() {
        this.state = {
            skus: [],
            tags: [],
            brands: []
        };
    }
    Object.defineProperty(Store.prototype, "skus", {
        get: function () {
            return this.state.skus;
        },
        set: function (skus) {
            this.state.skus = skus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "tags", {
        get: function () {
            return this.state.tags;
        },
        set: function (tags) {
            this.state.tags = tags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "brands", {
        get: function () {
            return this.state.brands;
        },
        set: function (brands) {
            this.state.brands = brands;
        },
        enumerable: true,
        configurable: true
    });
    return Store;
}());

/* harmony default export */ __webpack_exports__["a"] = (new Store());


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_ts_utils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_dom_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_html__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__masonry_scss__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__masonry_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__masonry_scss__);





/**
 * This component expects a "tilesAdded" event to be called when tiles have been added to it.
 * That kicks off setting tile width on the new tiles and positioning them in the layout.
 */
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__layout_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    name: 'MasonryLayout',
    data: function () {
        return {
            columnHeights: [],
            breakpoint: null,
            isRepositioning: false,
            maxColHeight: 0,
            numberOfColumns: 1,
            tileWidth: null,
            tileLeftPositions: []
        };
    },
    props: {
        breakpointsConfig: {
            type: Array,
            required: true
        },
        useProgressiveLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        layoutStyles: function () {
            // initial height of 200 will be adjusted as tiles are added
            return { height: (this.maxColHeight || 200) + "px" };
        }
    },
    methods: {
        recalculate: function () {
            // this method determines numberOfColumns and tileWidth
            var containerWidth = this.$parent.$el.clientWidth;
            // get the highest breakpoint where viewport is closest, but equal or above the
            // container width
            var bp = this.breakpointsConfig
                .filter(function (item) { return containerWidth >= item.viewport; })
                .sort(function (a, b) { return a.viewport > b.viewport ? -1 : 1; })[0];
            this.breakpoint = bp;
            if (bp.numOfCols) {
                // number of columns is specifically set.
                this.numberOfColumns = bp.numOfCols;
            }
            else {
                // number of columns is not specified, it's based on minWidth...
                // In order to figure out the numberOfColumns (x), we need to account for the gutter size
                // being (numberOfColumns - 1) * hSpacing.
                // That produces the following equation:
                // x = (containerWidth - (spacing * (x - 1))) / minWidth
                // Solving for x (numberOfColumns) we get:
                this.numberOfColumns =
                    Math.floor((containerWidth + bp.hSpacing) / (bp.minWidth + bp.hSpacing));
            }
            var gutterTotal = (this.numberOfColumns - 1) * bp.hSpacing;
            var calcTileWidth = Math.floor((containerWidth - gutterTotal) / this.numberOfColumns);
            // if it chooses maxWidth, means it is too wide and will leave extra space on the right
            // side of the pinboard.
            // TODO: should we make the gutter wider in that case?
            var tileWidth = bp.maxWidth ? Math.min(calcTileWidth, bp.maxWidth) : calcTileWidth;
            // If the tileWidth has not changed, there is nothing to do, return false to singify
            // it hasn't changed
            if (tileWidth === this.tileWidth) {
                return false;
            }
            this.tileWidth = tileWidth;
            // position of left-most column is always zero.  Only gutters between tiles
            this.tileLeftPositions = [0];
            this.columnHeights = [0];
            this.maxColHeight = 0;
            for (var i = 1; i < this.numberOfColumns; i++) {
                var previousColLeft = this.tileLeftPositions[i - 1];
                this.tileLeftPositions.push(previousColLeft + this.tileWidth + bp.hSpacing);
                this.columnHeights.push(0); // initialize each column height to zero
            }
            // returning true to signify the tileWidth has changed
            return true;
        },
        bindResize: function () {
            // remove event first so we don't accidentally add it twice
            window.removeEventListener('resize', this.onResize, false);
            window.addEventListener('resize', this.onResize, false);
        },
        bindScroll: function () {
            // make sure listener isn't already set
            this.removeScrollListener();
            if (this.useProgressiveLoading) {
                // load more on scroll to bottom
                window.addEventListener('scroll', this.onScroll, false);
            }
        },
        getMaxColHeight: function () {
            return this.columnHeights.reduce(function (max, val) {
                return max > val ? max : val;
            });
        },
        getMinHeightIndex: function () {
            var minIndex = 0;
            for (var i = 1; i < this.columnHeights.length; i++) {
                if (this.columnHeights[minIndex] > this.columnHeights[i]) {
                    minIndex = i;
                }
            }
            return minIndex;
        },
        onScroll: Object(__WEBPACK_IMPORTED_MODULE_1_util_ts_utils__["d" /* debounce */])(function cb() {
            // load more on scroll to bottom of the pinboard
            var scrollOffsetBottom = window.pageYOffset + window.innerHeight;
            var pinboardRect = this.$el.getBoundingClientRect();
            if (scrollOffsetBottom >= pinboardRect.top + pinboardRect.height) {
                this.removeScrollListener();
                // we've reached the bottom, notify the component using this layout that it can load more
                this.$emit('loadMore');
            }
        }, 50),
        removeScrollListener: function () {
            window.removeEventListener('scroll', this.onScroll, false);
        },
        positionTile: function (tiles, tileIndex) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                if (!_this.tileWidth || !_this.breakpoint) {
                    // not initialized through recalculate() yet
                    resolve();
                    return;
                }
                var tile = tiles[tileIndex];
                var colIndex = _this.getMinHeightIndex();
                tile.tileAttributes.left = _this.tileLeftPositions[colIndex];
                tile.tileAttributes.top = _this.columnHeights[colIndex];
                // making sure the changes to tile are reflected in the UI before calculating height
                _this.onTileReady(tile).then(function () {
                    // waiting until the tile is ready to display it and determine it's height
                    tile.tileAttributes.opacity = 1;
                    var newHeight = _this.columnHeights[colIndex] + tile.$el.offsetHeight + _this.breakpoint.vSpacing;
                    _this.setNewColHeight(colIndex, newHeight);
                    var nextTileIndex = tileIndex + 1;
                    if (tiles.length > nextTileIndex) {
                        _this.positionTile(tiles, nextTileIndex).then(function () {
                            resolve();
                        }).catch(function () {
                            reject();
                        });
                    }
                    else {
                        // no more to position, go ahead and resolve
                        resolve();
                    }
                });
            });
        },
        // should only be called through on tilesAdded or onResize to help avoid too many calls
        positionTiles: function (fromResize) {
            var _this = this;
            this.isRepositioning = true;
            try {
                var tiles = this.getSortedTiles();
                if (tiles.length > 0) {
                    // if not resizing, just need to position the new tiles
                    var tilesToPosition = fromResize ? tiles :
                        tiles.filter(function (t) { return t.tileAttributes.opacity !== 1; });
                    // clear the current heights if resizing or all new tiles
                    if (fromResize || tiles.length === tilesToPosition.length) {
                        this.columnHeights.forEach(function (h, i) { return _this.columnHeights[i] = 0; });
                    }
                    // positionTile is a recursive method so it can handle waiting for onTileReady before
                    // positioning the next tile
                    this.positionTile(tilesToPosition, 0).then(function () {
                        // just in case the maxHeight is actually supposed to be less than it was before
                        _this.maxHeight = _this.getMaxColHeight();
                        // Notify the component using this layout, that it is done
                        _this.$emit('doneLoading');
                        // once all tiles are positioned, we can allow positionTiles to be called again
                        // when checking for isRepositioning
                        _this.isRepositioning = false;
                        // TT-11340. Just in case the user is already positioned at the bottom of the pinboard
                        // with progressive loading on, see if more need to be loaded
                        // $nextTick is used to wait for doneLoading to have time
                        _this.$nextTick(function () {
                            if (_this.useProgressiveLoading) {
                                _this.onScroll();
                            }
                        });
                        // we can go ahead and bind the scroll event now that the tiles are all positioned
                        _this.bindScroll();
                    }).catch(function () {
                        // just in case
                        _this.isRepositioning = false;
                    });
                }
                else {
                    this.isRepositioning = false;
                }
            }
            catch (e) {
                this.isRepositioning = false;
            }
        },
        pushColumnDown: function (tile) {
            // using the tile's left position, we can tell which column it is in, then we can push down
            // all the other tiles that are in the same column (based on their left as well).
            var colIndex = this.tileLeftPositions.indexOf(tile.tileAttributes.left);
            var columnHeightFromThisTile = tile.tileAttributes.top + tile.$el.offsetHeight + this.breakpoint.vSpacing;
            var tiles = this.getSortedTiles();
            var heightDifference = 0; // the heightDifference is how much each tile needs to move down
            for (var i = (tile.tileOrder + 1); i < tiles.length; i++) {
                var nextTile = tiles[i];
                if (nextTile.tileAttributes.left === tile.tileAttributes.left) {
                    if (!heightDifference) {
                        // haven't set it yet, gets set with first tile that needs to be pushed down
                        heightDifference = columnHeightFromThisTile - nextTile.tileAttributes.top;
                    }
                    nextTile.tileAttributes.top += heightDifference;
                }
            }
            if (heightDifference) {
                this.setNewColHeight(colIndex, this.columnHeights[colIndex] + heightDifference);
            }
            else {
                // if heightDifference still hasn't been set, must be last tile in column
                this.setNewColHeight(colIndex, columnHeightFromThisTile);
            }
        },
        setNewColHeight: function (colIndex, newHeight) {
            this.columnHeights.splice(colIndex, 1, newHeight);
            var maxHeight = this.getMaxColHeight();
            if (this.maxColHeight < maxHeight) {
                this.maxColHeight = maxHeight;
            }
        },
        getSortedTiles: function () {
            // put into new array so we don't sort this.$children. according to Vue documentation, the
            // order of $children is not guaranteed, so we have an "order" on each tile to keep them in
            // the correct order
            var tiles = this.$children.slice(0);
            tiles.sort(function (a, b) { return a.tileOrder - b.tileOrder; });
            return tiles;
        },
        onResize: Object(__WEBPACK_IMPORTED_MODULE_1_util_ts_utils__["d" /* debounce */])(function cb() {
            if (this.recalculate()) {
                this.setWidthOnTiles();
                this.positionTiles(true);
            }
        }, 200),
        onTileReady: function (tile, attempts) {
            var _this = this;
            if (attempts === void 0) { attempts = 0; }
            // each tile has an isReady data element to signify it is ready to be drawn.
            // waiting for it to be true
            return new Promise(function (resolve, reject) {
                if (tile.isReady || attempts > 20) {
                    resolve();
                    return;
                }
                tile.$nextTick(function () {
                    window.requestAnimationFrame(function () {
                        _this.onTileReady(tile, attempts + 1).then(function () { return resolve(); });
                    });
                });
            });
        },
        setWidthOnTiles: function () {
            var tiles = this.getSortedTiles();
            for (var i = 0; i < tiles.length; i++) {
                tiles[i].setWidth(this.tileWidth);
            }
        }
    },
    created: function () {
        var _this = this;
        // this is called when tile have been added to the layout
        this.$on('tilesAdded', function () {
            if (_this.tileWidth > 0) {
                _this.setWidthOnTiles();
                _this.positionTiles();
            }
        });
        this.$on('tileHeightChanged', function (tile) {
            tile.$nextTick(function () {
                // TODO: could just call reset() instead.  Only problem is seeing some tiles below
                // this one getting moved around, instead of just the current column being pushed down.
                // Would simplify the layout code.  Other issues?
                _this.pushColumnDown(tile);
            });
        });
    },
    mounted: function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2_util_dom_utils__["a" /* default */].whenElementIsVisible(function () { return _this.$el; }).then(function () {
            _this.recalculate();
            _this.bindScroll();
        });
        this.bindResize();
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.onResize, false);
        this.removeScrollListener();
    },
    watch: {
        useProgressiveLoading: function () {
            if (this.useProgressiveLoading) {
                this.bindScroll();
            }
            else {
                this.removeScrollListener();
            }
        }
    }
})));

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-l-masonry", style: _vm.layoutStyles },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("033e556a", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("033e556a", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/util/turnto-utils.ts
var turnto_utils = __webpack_require__(11);

// EXTERNAL MODULE: ./src/util/browser-utils.ts
var browser_utils = __webpack_require__(16);

// EXTERNAL MODULE: ./src/util/text-utils.ts
var text_utils = __webpack_require__(22);

// EXTERNAL MODULE: ./src/services/social-sharing-service.ts
var social_sharing_service = __webpack_require__(60);

// EXTERNAL MODULE: ./src/layouts/masonry/tile-mixin.ts
var tile_mixin = __webpack_require__(49);

// EXTERNAL MODULE: ./src/filters/format-name.ts
var format_name = __webpack_require__(24);

// EXTERNAL MODULE: ./src/util/time-utils.ts
var time_utils = __webpack_require__(50);

// EXTERNAL MODULE: ./src/components/pinboard/pinboard-comment.html
var pinboard_comment = __webpack_require__(72);
var pinboard_comment_default = /*#__PURE__*/__webpack_require__.n(pinboard_comment);

// EXTERNAL MODULE: ./src/components/pinboard/pinboard-comment.scss
var pinboard_pinboard_comment = __webpack_require__(73);
var pinboard_pinboard_comment_default = /*#__PURE__*/__webpack_require__.n(pinboard_pinboard_comment);

// CONCATENATED MODULE: ./src/components/pinboard/pinboard-comment.ts






/* harmony default export */ var components_pinboard_pinboard_comment = (pinboard_comment_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            isTextTruncated: false,
            isUserNameTruncated: false
        };
    },
    props: {
        comment: {
            type: Object,
            required: true
        },
        commentMaxLength: {
            type: Number,
            required: true
        },
        // hard-coded as it is in 4.3.  May make a config option as we have for other widgets
        truncateAllowance: {
            type: Number,
            default: 9
        },
        userNameMaxLength: {
            type: Number,
            required: true
        }
    },
    computed: {
        commentText: function () {
            return this.isTextTruncated ? this.truncatedText : this.comment.text;
        },
        elapsedTime: function () {
            return Object(time_utils["a" /* getElapsedTime */])(this.comment.dateCreatedMillis);
        },
        truncatedText: function () {
            var text = this.comment.text.trim();
            return Object(text_utils["a" /* truncateText */])(text, this.commentMaxLength, this.truncateAllowance);
        },
        author: function () {
            var formattedName = Object(format_name["a" /* default */])(this.comment.user);
            this.isUserNameTruncated = formattedName.length > this.userNameMaxLength;
            return this.isUserNameTruncated ?
                formattedName.substring(0, this.userNameMaxLength) : formattedName;
        }
    },
    methods: {
        expandComment: function () {
            this.isTextTruncated = false;
            // notify the pinboard item that a comment is expanding. This eventually bubbles up
            // to the Masonry Layout (layout.ts) to adjust the other pins to make room.
            this.$emit('expanded', this);
        }
    },
    created: function () {
        if (this.truncatedText) {
            this.isTextTruncated = true;
        }
    }
})));

// EXTERNAL MODULE: ./src/objects/product-image/product-image.ts
var product_image = __webpack_require__(23);

// EXTERNAL MODULE: ./src/components/rating/rating-stars.ts
var rating_stars = __webpack_require__(26);

// EXTERNAL MODULE: ./src/components/pinboard/comments-pinboard-item.html
var comments_pinboard_item = __webpack_require__(74);
var comments_pinboard_item_default = /*#__PURE__*/__webpack_require__.n(comments_pinboard_item);

// EXTERNAL MODULE: ./src/components/pinboard/comments-pinboard-item.scss
var pinboard_comments_pinboard_item = __webpack_require__(75);
var pinboard_comments_pinboard_item_default = /*#__PURE__*/__webpack_require__.n(pinboard_comments_pinboard_item);

// CONCATENATED MODULE: ./src/components/pinboard/comments-pinboard-item.ts











/* harmony default export */ var components_pinboard_comments_pinboard_item = __webpack_exports__["a"] = (comments_pinboard_item_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            // TT-11794 - showActions is to help hold actions visible when going to focus on button
            // Also used to help move the actions outside of the anchor tag.
            showActions: false,
            commentsForDisplay: []
        };
    },
    props: {
        commentMaxLength: {
            type: Number,
            required: true
        },
        // if passed, will render the "see x more comments" section
        commentsCount: { type: Number },
        hoverTitleMaxLength: {
            type: Number,
            required: true
        },
        item: {
            type: Object,
            required: true
        },
        // For pinboard teaser where it should display 1 or 2 comments depending on number of lines
        linesLimit: Number,
        showReviewStars: Boolean,
        showSocialSharing: Boolean,
        titleMaxLength: {
            type: Number,
            required: true
        },
        // hard-coded as it is in 4.3.  May make a config option as we have for other widgets
        truncateAllowance: {
            type: Number,
            default: 9
        },
        userNameMaxLength: {
            type: Number,
            required: true
        }
    },
    mixins: [tile_mixin["a" /* default */]],
    components: {
        'tt-pinboard-comment': components_pinboard_pinboard_comment,
        'tt-product-image': product_image["a" /* default */],
        'tt-rating-stars': rating_stars["a" /* default */]
    },
    computed: {
        displayReviewStars: function () {
            return this.item.reviewCount > 0 && this.showReviewStars;
        },
        hoverTitle: function () {
            var truncated = Object(text_utils["a" /* truncateText */])(this.item.title, this.hoverTitleMaxLength);
            return truncated ? truncated + "&hellip;" : this.item.title;
        },
        isOnMobile: function () {
            return Object(browser_utils["i" /* isMobileDevice */])();
        },
        title: function () {
            var truncated = Object(text_utils["a" /* truncateText */])(this.item.title, this.titleMaxLength);
            return truncated ? truncated + "&hellip;" : this.item.title;
        },
        productLink: function () {
            // TODO: needs to be a translink.  Not sure yet how handling in v5
            return this.item.url;
        },
        seeMoreText: function () {
            var count = this.commentsCount;
            if (count !== undefined) {
                return this.$msg('commentsPinboardTeaser.moreComments', [count], count);
            }
            return null;
        },
        tileWidth: function () {
            return this.tileAttributes.width;
        }
    },
    methods: {
        commentExpanded: function () {
            // one of the child pinboard comments expanded, so calling the tileMixin to notify the layout
            // that this item has expanded
            this.tileHeightChanged();
        },
        onShowActions: function () {
            this.showActions = true;
        },
        onHideActions: function () {
            this.showActions = false;
        },
        openFacebookWindow: function () {
            Object(social_sharing_service["a" /* openFacebookShare */])(this.item.url);
        },
        openPinterestWindow: function () {
            Object(social_sharing_service["b" /* openPinterestShare */])(this.item.url, Object(turnto_utils["e" /* getProductImageUrl */])(this.item), this.item.title);
        },
        openTwitterWindow: function () {
            Object(social_sharing_service["c" /* openTwitterShare */])(this.item.url, this.item.title);
        }
    },
    created: function () {
        this.commentsForDisplay = this.item.comments;
    },
    mounted: function () {
        if (this.linesLimit) {
            // The code below is not ideal, especially looking up an element in the child component
            // by it's class name. Would like to have better way to handle these requirements.
            // Determining if we need to hide a comment.
            // The rules go as follows:
            // 1) If the 1st comment is > linesLimit lines, just show it (hide the 2nd)
            // 2) If the 1st comment is <=linesLimit lines, and the 2nd comment is >linesLimit lines,
            //    show it and hide the first
            // 3) That should leave the final option as both comments having <=linesLimit lines,
            //    in which case we will show both.
            var commentTextElements = this.$el.querySelectorAll('.tt-c-pinboard-comment__text');
            var numberOfLines = [];
            // should only be two comments, but making sure at least 2
            if (commentTextElements.length >= 2) {
                for (var i = 0; i < commentTextElements.length; i++) {
                    // Checking number of lines the comment takes with a method described here:
                    // http://rickeyre.ca/2014/04/15/number-of-lines-of-text.html
                    var item = commentTextElements[i];
                    item.style.display = 'inline';
                    numberOfLines.push(item.getClientRects().length);
                    item.style.display = null;
                }
                if (numberOfLines[0] > this.linesLimit) {
                    this.commentsForDisplay = this.item.comments.slice(0, 1);
                }
                else if (numberOfLines[1] > this.linesLimit) {
                    this.commentsForDisplay = this.item.comments.slice(1, 2);
                }
            }
        }
        // from tileMixin
        if (this.isTile) {
            this.isReady = true;
        }
    },
    watch: {
        tileWidth: function () {
            var _this = this;
            // watching for the tile width that comes from the mixin.  This is changed when the
            // layout sets the width. When changed, setting the height, then setting isReady to true
            // so that the positioning of the tiles gets redrawn
            if (this.isTile) {
                this.$refs.productImage.$el.style.height = this.tileWidth + "px";
                this.$nextTick(function () {
                    _this.isReady = true;
                });
            }
        }
    }
})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("figcaption", { staticClass: "tt-c-pinboard-comment" }, [
    _c(
      "span",
      { staticClass: "tt-c-pinboard-comment__text" },
      [
        _vm._v(_vm._s(_vm.commentText)),
        _vm.isTextTruncated ? [_vm._v("… ")] : _vm._e(),
        _vm.isTextTruncated
          ? _c("tt-button", {
              staticClass: "tt-c-pinboard-comment__text-expand",
              attrs: { type: "link" },
              domProps: {
                innerHTML: _vm._s(_vm.$msg("commentsPinboardItem.readMore"))
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.expandComment($event)
                }
              }
            })
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "tt-c-pinboard-comment__author" },
      [
        _vm._v(_vm._s(_vm.author)),
        _vm.isUserNameTruncated ? [_vm._v("…")] : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c("span", {
      staticClass: "tt-c-pinboard-comment__timestamp",
      domProps: { innerHTML: _vm._s(_vm.elapsedTime) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("022ec43c", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("022ec43c", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    { staticClass: "tt-c-comments-pin", style: _vm.tileStyles },
    [
      _c(
        "div",
        {
          staticClass: "tt-c-comments-pin__image-wrapper",
          on: { mouseover: _vm.onShowActions, mouseout: _vm.onHideActions }
        },
        [
          _c(
            "a",
            {
              staticClass: "tt-c-comments-pin__item-link tt-u-ignore-default",
              attrs: {
                href: _vm.productLink,
                target: "_blank",
                title: _vm.$msg("commentsPinboardItem.goToPageForProduct", [
                  _vm.item.title
                ]),
                tabindex: "0",
                rel: "nofollow"
              },
              on: { focus: _vm.onShowActions, blur: _vm.onHideActions }
            },
            [
              _c("tt-product-image", {
                ref: "productImage",
                staticClass: "tt-c-comments-pin__image",
                attrs: { catItem: _vm.item, includeAlt: false, size: "L" }
              }),
              _vm._v(" "),
              !_vm.isOnMobile
                ? _c(
                    "div",
                    {
                      staticClass: "tt-c-comments-pin__product-info",
                      class: {
                        "tt-c-comments-pin__product-info--hover":
                          _vm.showActions
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "tt-c-comments-pin__hover-product-name",
                        domProps: { innerHTML: _vm._s(_vm.hoverTitle) }
                      }),
                      _vm._v(" "),
                      _vm.displayReviewStars
                        ? _c("tt-rating-stars", {
                            staticClass:
                              "tt-c-comments-pin__rating tt-c-rating--knockout",
                            attrs: { rating: _vm.item.averageRating }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isOnMobile
            ? _c(
                "div",
                {
                  staticClass: "tt-c-comments-pin-actions",
                  class: { "tt-c-comments-pin-actions--hover": _vm.showActions }
                },
                [
                  _vm.showSocialSharing
                    ? _c(
                        "div",
                        { staticClass: "tt-c-comments-pin-actions__group" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "tt-c-comments-pin-actions__icon tt-c-comments-pin-actions__icon--facebook",
                              attrs: {
                                role: "button",
                                "aria-label": _vm.$msg(
                                  "commentsPinboardItem.shareOnFacebook"
                                ),
                                tabindex: "0"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openFacebookWindow($event)
                                },
                                keydown: function($event) {
                                  if (
                                    !("button" in $event) &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.openFacebookWindow($event)
                                },
                                focus: _vm.onShowActions,
                                blur: _vm.onHideActions
                              }
                            },
                            [
                              _c("tt-icon", {
                                attrs: { name: "social-facebook" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "tt-c-comments-pin-actions__icon tt-c-comments-pin-actions__icon--twitter",
                              attrs: {
                                role: "button",
                                "aria-label": _vm.$msg(
                                  "commentsPinboardItem.shareOnTwitter"
                                ),
                                tabindex: "0"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openTwitterWindow($event)
                                },
                                keydown: function($event) {
                                  if (
                                    !("button" in $event) &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.openTwitterWindow($event)
                                },
                                focus: _vm.onShowActions,
                                blur: _vm.onHideActions
                              }
                            },
                            [
                              _c("tt-icon", {
                                attrs: { name: "social-twitter" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "tt-c-comments-pin-actions__icon tt-c-comments-pin-actions__icon--pinterest",
                              attrs: {
                                role: "button",
                                "aria-label": _vm.$msg(
                                  "commentsPinboardItem.shareOnPinterest"
                                ),
                                tabindex: "0"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openPinterestWindow($event)
                                },
                                keydown: function($event) {
                                  if (
                                    !("button" in $event) &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.openPinterestWindow($event)
                                },
                                focus: _vm.onShowActions,
                                blur: _vm.onHideActions
                              }
                            },
                            [
                              _c("tt-icon", {
                                attrs: { name: "social-pinterest" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("span", {
        staticClass: "tt-c-comments-pin__product-name",
        domProps: { innerHTML: _vm._s(_vm.title) }
      }),
      _vm._v(" "),
      _vm._l(_vm.commentsForDisplay, function(comment) {
        return _c("tt-pinboard-comment", {
          key: comment.id,
          attrs: {
            comment: comment,
            commentMaxLength: _vm.commentMaxLength,
            userNameMaxLength: _vm.userNameMaxLength
          },
          on: { expanded: _vm.commentExpanded }
        })
      }),
      _vm._v(" "),
      _vm.seeMoreText
        ? _c(
            "a",
            {
              staticClass: "tt-c-comments-pin__cta tt-u-ignore-default",
              attrs: {
                href: _vm.productLink,
                target: "_blank",
                rel: "nofollow"
              }
            },
            [
              _c("span", {
                staticClass: "tt-c-comments-pin__cta-text",
                domProps: { innerHTML: _vm._s(_vm.seeMoreText) }
              }),
              _c("tt-icon", {
                staticClass: "tt-c-comments-pin__cta-arrow",
                attrs: { name: "caret-right", size: "sm" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("fee94c6e", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("fee94c6e", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommentsPinboardConfig */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultConfig; });
var CommentsPinboardConfig = /** @class */ (function () {
    function CommentsPinboardConfig(config) {
        this.activeOnly = config.activeOnly;
        this.breakpointsConfig = config.breakpointsConfig;
        this.commentMaxLength = config.commentMaxLength;
        this.hoverTitleMaxLength = config.hoverTitleMaxLength;
        this.includeSyndicated = config.includeSyndicated;
        this.limit = config.limit;
        this.maxCommentsReturned = config.maxCommentsReturned;
        this.maxDaysOld = config.maxDaysOld;
        this.progressiveLoading = config.progressiveLoading;
        this.showReviewStars = config.showReviewStars;
        this.titleMaxLength = config.titleMaxLength;
        this.userNameMaxLength = config.userNameMaxLength;
        this.widgetDivId = config.widgetDivId;
    }
    return CommentsPinboardConfig;
}());

var defaultConfig = {};
function loadConfig(config) {
    defaultConfig = new CommentsPinboardConfig(config);
}



/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadConfig", function() { return loadConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_entry_base__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_command_queue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_global_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_email_flows_email_flow_entry__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_init_global_config__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_init_resource_loader__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_msg__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widgets_comments_pinboard_comments_pinboard_loader__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_token_service__ = __webpack_require__(15);
/* tslint:disable */
// (AUTO-GENERATED PAGE BUNDLE)
// PAGE NAME: non-defined-page
// ==============================









function loadConfig(config) {
    Object(__WEBPACK_IMPORTED_MODULE_5_init_resource_loader__["c" /* loadIcons */])(__webpack_require__(154));
    Object(__WEBPACK_IMPORTED_MODULE_6_services_msg__["c" /* loadMessages */])(config.messages, config.pluralRuleFn);
    Object(__WEBPACK_IMPORTED_MODULE_4_init_global_config__["b" /* loadConfig */])(config.globalConfig);
    Promise.all([
        __WEBPACK_IMPORTED_MODULE_7_widgets_comments_pinboard_comments_pinboard_loader__["loadWidget"](config.commentsPinboard)
    ]).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_init_global_store__["a" /* default */].loaders = [
            __WEBPACK_IMPORTED_MODULE_7_widgets_comments_pinboard_comments_pinboard_loader__
        ];
        __WEBPACK_IMPORTED_MODULE_1_init_command_queue__["a" /* init */]();
    });
    Object(__WEBPACK_IMPORTED_MODULE_8_services_token_service__["b" /* loadLoggedInUser */])();
    Object(__WEBPACK_IMPORTED_MODULE_3_email_flows_email_flow_entry__["a" /* checkTurntoflow */])();
}


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "type", function() { return type; });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["loadWidget"] = loadWidget;
/* harmony export (immutable) */ __webpack_exports__["getInstance"] = getInstance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_loader_helper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_command_queue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comments_pinboard_commands__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_comments_pinboard_store__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comments_pinboard_config__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__comments_pinboard__ = __webpack_require__(151);






var root;
var type = 'comments-pinboard';
function initialize() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_util_loader_helper__["a" /* createAndMountInstance */])(root, __WEBPACK_IMPORTED_MODULE_5__comments_pinboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__comments_pinboard_config__["a" /* default */].widgetDivId)
        .then(function (instance) { return root = instance; });
}
function loadWidget(widgetConfig) {
    return new Promise(function (resolve) {
        Object(__WEBPACK_IMPORTED_MODULE_4__comments_pinboard_config__["b" /* loadConfig */])(widgetConfig);
        __WEBPACK_IMPORTED_MODULE_1_init_command_queue__["b" /* widgetLibraries */].commentsPinboard = __WEBPACK_IMPORTED_MODULE_2__comments_pinboard_commands__;
        // check turnToConfig for filter values (skus, brands, tags)
        var pinboardTurnToConfig = window.turnToConfig.commentsPinboard || {};
        __WEBPACK_IMPORTED_MODULE_3_store_comments_pinboard_store__["a" /* default */].brands = pinboardTurnToConfig.brands || [];
        __WEBPACK_IMPORTED_MODULE_3_store_comments_pinboard_store__["a" /* default */].skus = pinboardTurnToConfig.skus || [];
        __WEBPACK_IMPORTED_MODULE_3_store_comments_pinboard_store__["a" /* default */].tags = pinboardTurnToConfig.tags || [];
        initialize().then(function () { return resolve(); });
    });
}
function getInstance() {
    return root;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store_comments_pinboard_store__ = __webpack_require__(67);

/**
 * Command for client to set the pinboard with different filters based
 * on skus, brands, and/or tags.
 * @param resetValues - {skus, brands, tags}
 */
function set(values) {
    __WEBPACK_IMPORTED_MODULE_0_store_comments_pinboard_store__["a" /* default */].skus = values.skus || [];
    __WEBPACK_IMPORTED_MODULE_0_store_comments_pinboard_store__["a" /* default */].tags = values.tags || [];
    __WEBPACK_IMPORTED_MODULE_0_store_comments_pinboard_store__["a" /* default */].brands = values.brands || [];
}


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_service__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_dom_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widgets_comments_pinboard_comments_pinboard_config__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_comments_pinboard_store__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_turnto_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_layouts_masonry_layout__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_pinboard_comments_pinboard_item__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__comments_pinboard_html__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__comments_pinboard_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__comments_pinboard_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__comments_pinboard_scss__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__comments_pinboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__comments_pinboard_scss__);










/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8__comments_pinboard_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return {
            hasMore: true,
            isLoading: false,
            items: [],
            offset: 0,
            pinboardStore: __WEBPACK_IMPORTED_MODULE_4_store_comments_pinboard_store__["a" /* default */]
        };
    },
    components: {
        'tt-masonry-layout': __WEBPACK_IMPORTED_MODULE_6_layouts_masonry_layout__["a" /* default */],
        'tt-pinboard-item': __WEBPACK_IMPORTED_MODULE_7_components_pinboard_comments_pinboard_item__["a" /* default */]
    },
    computed: {
        currentFilters: function () {
            return {
                skus: this.pinboardStore.skus,
                tags: this.pinboardStore.tags,
                brands: this.pinboardStore.brands
            };
        },
        displayShowMoreButton: function () {
            return !__WEBPACK_IMPORTED_MODULE_3_widgets_comments_pinboard_comments_pinboard_config__["a" /* default */].progressiveLoading && !this.isLoading &&
                this.offset > 0 && this.hasMore;
        },
        displayShowMoreWrapper: function () {
            return this.items.length > 0 && (this.displayShowMoreButton || this.isLoading);
        },
        pinboardConfig: function () {
            return __WEBPACK_IMPORTED_MODULE_3_widgets_comments_pinboard_comments_pinboard_config__["a" /* default */];
        },
        useProgressiveLoading: function () {
            return this.hasMore && __WEBPACK_IMPORTED_MODULE_3_widgets_comments_pinboard_comments_pinboard_config__["a" /* default */].progressiveLoading && !this.isLoading;
        }
    },
    methods: {
        doneLoading: function () {
            this.isLoading = false;
        },
        fetchData: function () {
            var _this = this;
            if (this.hasMore && !this.isLoading) {
                this.isLoading = true;
                __WEBPACK_IMPORTED_MODULE_1_services_api_service__["a" /* default */].getCatalogItemsForCommentsPinboard({
                    offset: this.offset,
                    limit: __WEBPACK_IMPORTED_MODULE_3_widgets_comments_pinboard_comments_pinboard_config__["a" /* default */].limit,
                    activeOnly: __WEBPACK_IMPORTED_MODULE_3_widgets_comments_pinboard_comments_pinboard_config__["a" /* default */].activeOnly,
                    brands: Object(__WEBPACK_IMPORTED_MODULE_5_util_turnto_utils__["c" /* encodeArray */])(__WEBPACK_IMPORTED_MODULE_4_store_comments_pinboard_store__["a" /* default */].brands),
                    skus: Object(__WEBPACK_IMPORTED_MODULE_5_util_turnto_utils__["c" /* encodeArray */])(__WEBPACK_IMPORTED_MODULE_4_store_comments_pinboard_store__["a" /* default */].skus),
                    tags: Object(__WEBPACK_IMPORTED_MODULE_5_util_turnto_utils__["c" /* encodeArray */])(__WEBPACK_IMPORTED_MODULE_4_store_comments_pinboard_store__["a" /* default */].tags),
                    includeCommentsCount: false,
                    includeReviewData: __WEBPACK_IMPORTED_MODULE_3_widgets_comments_pinboard_comments_pinboard_config__["a" /* default */].showReviewStars,
                    maxDaysOld: __WEBPACK_IMPORTED_MODULE_3_widgets_comments_pinboard_comments_pinboard_config__["a" /* default */].maxDaysOld,
                    includeSyndicated: __WEBPACK_IMPORTED_MODULE_3_widgets_comments_pinboard_comments_pinboard_config__["a" /* default */].includeSyndicated,
                    minComments: 1,
                    maxCommentsReturned: __WEBPACK_IMPORTED_MODULE_3_widgets_comments_pinboard_comments_pinboard_config__["a" /* default */].maxCommentsReturned
                }).then(function (data) {
                    if (data.catalogItems.length === 0) {
                        // if there are items the MasonryLayout will call this.doneLoading() to set to false
                        _this.isLoading = false;
                    }
                    // grabbing the last few ids to make sure we don't put a dup item in from this batch.
                    // this can happen when an item gets mediated out in between page loads.  Yes, unlikely,
                    // but happened in prod with previous version causing some layout issues.
                    var ids = _this.items.slice(-10).map(function (item) { return item.id; });
                    data.catalogItems.forEach(function (item, i) {
                        if (!~ids.indexOf(item.id)) {
                            _this.items.push(item);
                        }
                    });
                    _this.hasMore = data.hasMore;
                    _this.$nextTick(function () {
                        __WEBPACK_IMPORTED_MODULE_2_util_dom_utils__["a" /* default */].whenRefIsVisible(_this.$refs, 'layout').then(function () {
                            // notify the layout that tiles have been added
                            _this.$refs.layout.$emit('tilesAdded');
                        });
                    });
                    // only called on first load
                    if (_this.offset === 0) {
                        _this.onFinish();
                    }
                    _this.offset += data.catalogItems.length;
                }).catch(function () { return _this.isLoading = false; });
            }
        },
        onFinish: function () {
            // if client provided an onFinish function
            var turnToPinboardConfig = window.turnToConfig.commentsPinboard || {};
            if (turnToPinboardConfig.onFinish) {
                this.$nextTick(function () {
                    turnToPinboardConfig.onFinish();
                });
            }
        },
        showMore: function () {
            this.fetchData();
        }
    },
    watch: {
        // whenever one of the filters changes (skus, tags, or brands), we need to reload the pinboard
        currentFilters: {
            handler: function () {
                this.offset = 0;
                this.hasMore = true;
                this.items = [];
                this.fetchData();
            },
            deep: true
        }
    },
    created: function () {
        this.fetchData();
    }
})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-w-comments-pinboard" },
    [
      _vm.items.length > 0
        ? _c(
            "tt-masonry-layout",
            {
              ref: "layout",
              class: "tt-w-comments-pinboard__list",
              attrs: {
                breakpointsConfig: _vm.pinboardConfig.breakpointsConfig,
                useProgressiveLoading: _vm.useProgressiveLoading
              },
              on: { loadMore: _vm.fetchData, doneLoading: _vm.doneLoading }
            },
            _vm._l(_vm.items, function(item, index) {
              return _c("tt-pinboard-item", {
                key: item.id,
                attrs: {
                  item: item,
                  tileOrder: index,
                  commentMaxLength: _vm.pinboardConfig.commentMaxLength,
                  hoverTitleMaxLength: _vm.pinboardConfig.hoverTitleMaxLength,
                  showReviewStars: _vm.pinboardConfig.showReviewStars,
                  showSocialSharing: true,
                  titleMaxLength: _vm.pinboardConfig.titleMaxLength,
                  userNameMaxLength: _vm.pinboardConfig.userNameMaxLength
                }
              })
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayShowMoreWrapper
        ? _c(
            "div",
            { staticClass: "tt-w-comments-pinboard__show-more-wrapper" },
            [
              _c("tt-button", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.displayShowMoreButton,
                    expression: "displayShowMoreButton"
                  }
                ],
                staticClass: "tt-w-comments-pinboard__show-more",
                attrs: { type: "primary" },
                domProps: {
                  innerHTML: _vm._s(_vm.$msg("commentsPinboard.showMore"))
                },
                on: { click: _vm.showMore }
              }),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoading,
                    expression: "isLoading"
                  }
                ],
                staticClass: "tt-o-spinner tt-w-comments-pinboard__loading"
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("68d42be9", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("68d42be9", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arrow-fill.svg": 155,
	"./back-arrow.svg": 156,
	"./bell.svg": 157,
	"./caret-down.svg": 158,
	"./caret-left.svg": 159,
	"./caret-right.svg": 160,
	"./check.svg": 161,
	"./checkbox--off.svg": 162,
	"./checkbox--on.svg": 163,
	"./close.svg": 164,
	"./controls.svg": 165,
	"./delete.svg": 166,
	"./error.svg": 167,
	"./flag-off.svg": 168,
	"./flag-on.svg": 169,
	"./heart.svg": 170,
	"./helpful-off.svg": 171,
	"./helpful-on.svg": 172,
	"./info.svg": 173,
	"./logout.svg": 174,
	"./moderate.svg": 175,
	"./more-H.svg": 176,
	"./next-arrow.svg": 177,
	"./options-collapse.svg": 178,
	"./options-expand.svg": 179,
	"./photo.svg": 180,
	"./posts.svg": 181,
	"./profile.svg": 182,
	"./question.svg": 183,
	"./quote.svg": 184,
	"./reply.svg": 185,
	"./search.svg": 186,
	"./settings.svg": 187,
	"./social-facebook.svg": 188,
	"./social-google.svg": 189,
	"./social-pinterest.svg": 190,
	"./social-twitter.svg": 191,
	"./sort.svg": 192,
	"./star--empty.svg": 193,
	"./star--full.svg": 194,
	"./star--half.svg": 195,
	"./unhelpful-off.svg": 196,
	"./unhelpful-on.svg": 197,
	"./video.svg": 198,
	"./vote-off.svg": 199,
	"./vote-on.svg": 200,
	"./write.svg": 201
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-arrow-fill\" viewBox=\"0 0 24 24\"><path d=\"M0 6.09C3.9 10 8.1 14 12 17.91 16.1 14 19.9 10 24 6.09z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-back-arrow\" viewBox=\"0 0 24 24\"><path d=\"M24 10.53v2.94H5.75l8.36 8.42L12 24 0 12 12 0l2.11 2.11-8.36 8.42H24z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-bell\" viewBox=\"0 0 24 24\"><path d=\"M4.25 17.19h15.5a7 7 0 0 1-2.56-5.4V8.1a5.19 5.19 0 0 0-10.38 0v3.69a7 7 0 0 1-2.56 5.4zm19.44 2.6H.31v-3.53L1.2 16a4.39 4.39 0 0 0 3-4.17V8.1a7.79 7.79 0 0 1 15.58 0v3.69a4.39 4.39 0 0 0 3 4.17l.89.3zm-16.16 1.3h8.94a5.14 5.14 0 0 1-8.94 0z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-caret-down\" viewBox=\"0 0 24 24\"><path d=\"M2.7 5.23L.16 7.6 12 18.77 23.84 7.6 21.3 5.23l-9.3 8.8-9.3-8.8z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-caret-left\" viewBox=\"0 0 24 24\"><path d=\"M18.86 2.57L16.46 0 5.14 12l11.32 12 2.4-2.57L9.94 12l8.92-9.43z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-caret-right\" viewBox=\"0 0 24 24\"><path d=\"M14.06 12l-8.92 9.43L7.54 24l11.32-12L7.54 0l-2.4 2.57L14.06 12z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-check\" viewBox=\"0 0 24 24\"><path d=\"M7.47 21.98L.14 14.65l2.63-2.63 4.57 4.58L20.92 1.67l2.75 2.5-16.2 17.81z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-checkbox--off\" viewBox=\"0 0 32 32\"><path d=\"M28 0H4C1.8 0 0 1.8 0 4v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zm0 28H4V4h24v24z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-checkbox--on\" viewBox=\"0 0 32 32\"><path d=\"M28 0H4C1.8 0 0 1.8 0 4v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zM14 24.828l-7.414-7.414 2.828-2.828L14 19.172l9.586-9.586 2.828 2.828L14 24.828z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-close\" viewBox=\"0 0 24 24\"><path d=\"M23.44 2.86L14.3 12l9.14 9.14-2.3 2.3L12 14.3l-9.14 9.14-2.3-2.3L9.7 12 .56 2.86l2.3-2.3L12 9.7 21.14.56z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-controls\" viewBox=\"0 0 24 24\"><path d=\"M.17 5.85v2.39h3.92a3.77 3.77 0 0 0 3.7 2.68 3.79 3.79 0 0 0 3.71-2.68h12.33V5.85H11.52a4.11 4.11 0 0 0-3.73-2.72 4.13 4.13 0 0 0-3.73 2.72zM19.91 14.93a4.11 4.11 0 0 0-3.73-2.72 4.13 4.13 0 0 0-3.73 2.72H.17v2.39h12.31a3.76 3.76 0 0 0 3.7 2.68 3.78 3.78 0 0 0 3.71-2.68h3.94v-2.39z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-delete\" viewBox=\"0 0 24 24\"><path d=\"M3.34 21.28a2.48 2.48 0 0 0 2.47 2.47h12.37a2.48 2.48 0 0 0 2.47-2.47V6.43H3.34zM5.82 8.91h12.36v12.37H5.82zm9.89-6.18h7.42V5.2H.87V2.72h7.42V.25h7.42zm-7.42 8.65v7.42h2.47v-7.42zm4.95 0v7.42h2.47v-7.42z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-error\" viewBox=\"0 0 24 24\"><path d=\"M23.65 11.15L12.85.35a1.2 1.2 0 0 0-1.7 0L.35 11.15a1.2 1.2 0 0 0 0 1.7l10.8 10.8a1.21 1.21 0 0 0 1.7 0l10.8-10.8a1.2 1.2 0 0 0 0-1.7zM12 21.1L2.9 12 12 2.9l9.1 9.1z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M10.8 7.2h2.4v7.2h-2.4z\"/><circle cx=\"12\" cy=\"16.8\" r=\"1.5\"/></symbol>"

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-flag-off\" viewBox=\"0 0 24 24\"><path d=\"M16.52 2.64l5.75.36v13.83h-8.44l-2.75-2.72h-6.7v9.66H1.73V.23h12.1zm-.87 2.26l-2.32-2.15H4.25v8.43h7.66l2.95 2.32L20 14.61V6.22z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-flag-on\" viewBox=\"0 0 24 24\"><path d=\"M16.52 2.64l5.75.36v13.83h-8.44l-2.75-2.72h-6.7v9.66H1.73V.23h12.1z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-heart\" viewBox=\"0 0 24 24\"><path d=\"M12.11 19.6q2.67-2.39 4-3.62t2.78-2.9a12.35 12.35 0 0 0 2.09-3 6 6 0 0 0 .58-2.51 4 4 0 0 0-1.2-3 4.09 4.09 0 0 0-3-1.17 4.65 4.65 0 0 0-2.59.78 4 4 0 0 0-1.64 2h-2.24a4 4 0 0 0-1.64-2 4.65 4.65 0 0 0-2.59-.78 4.09 4.09 0 0 0-3 1.17 4 4 0 0 0-1.2 3 6 6 0 0 0 .58 2.51 12.35 12.35 0 0 0 2.09 3q1.5 1.67 2.78 2.9t4 3.62l.11.11zm5.24-18.49A6.26 6.26 0 0 1 22 3a6.34 6.34 0 0 1 1.87 4.62 8.4 8.4 0 0 1-.61 3.15A12.65 12.65 0 0 1 21 14.2q-1.64 1.89-3 3.17t-4.29 4L12 22.89l-1.73-1.5q-3.84-3.46-5.54-5.19a23.1 23.1 0 0 1-3.15-4.06A8.58 8.58 0 0 1 .14 7.63 6.34 6.34 0 0 1 2 3a6.26 6.26 0 0 1 4.65-1.89A6.7 6.7 0 0 1 12 3.62a6.7 6.7 0 0 1 5.35-2.51z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M17.35 1.11A6.26 6.26 0 0 1 22 3a6.34 6.34 0 0 1 1.87 4.62 8.4 8.4 0 0 1-.61 3.15A12.65 12.65 0 0 1 21 14.2q-1.64 1.89-3 3.17t-4.29 4L12 22.89l-1.73-1.5q-3.84-3.46-5.54-5.19a23.1 23.1 0 0 1-3.15-4.06A8.58 8.58 0 0 1 .14 7.63 6.34 6.34 0 0 1 2 3a6.26 6.26 0 0 1 4.65-1.89A6.7 6.7 0 0 1 12 3.62a6.7 6.7 0 0 1 5.35-2.51z\"/></symbol>"

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-helpful-off\" viewBox=\"0 0 24 24\"><path d=\"M12.11 19.69c1.81-1.61 3.14-2.84 4-3.66s1.81-1.8 2.82-2.93a12.41 12.41 0 0 0 2.11-3 6 6 0 0 0 .59-2.53 4 4 0 0 0-1.21-3 4.12 4.12 0 0 0-3-1.18 4.68 4.68 0 0 0-2.62.79 4 4 0 0 0-1.66 2h-2.27a4 4 0 0 0-1.66-2 4.68 4.68 0 0 0-2.62-.79 4.12 4.12 0 0 0-3 1.18 4 4 0 0 0-1.21 3A6 6 0 0 0 3 10.11a12.41 12.41 0 0 0 2.11 3C6.08 14.23 7 15.2 7.89 16s2.19 2 4 3.66l.11.11zM17.41 1a6.31 6.31 0 0 1 4.7 1.91A6.42 6.42 0 0 1 24 7.58a8.53 8.53 0 0 1-.62 3.18 12.77 12.77 0 0 1-2.28 3.47c-1.11 1.27-2.11 2.34-3 3.21s-2.34 2.19-4.33 4L12 23l-1.75-1.52c-2.59-2.33-4.46-4.07-5.6-5.24a23.08 23.08 0 0 1-3.19-4.11A8.75 8.75 0 0 1 0 7.58 6.42 6.42 0 0 1 1.89 2.9 6.31 6.31 0 0 1 6.59 1 6.78 6.78 0 0 1 12 3.52 6.78 6.78 0 0 1 17.41 1z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-helpful-on\" viewBox=\"0 0 24 24\"><path d=\"M17.41 1a6.31 6.31 0 0 1 4.7 1.91A6.42 6.42 0 0 1 24 7.58a8.53 8.53 0 0 1-.62 3.18 12.77 12.77 0 0 1-2.28 3.47c-1.11 1.27-2.11 2.34-3 3.21s-2.34 2.19-4.33 4L12 23l-1.75-1.52c-2.59-2.33-4.46-4.07-5.6-5.24a23.08 23.08 0 0 1-3.19-4.11A8.75 8.75 0 0 1 0 7.58 6.42 6.42 0 0 1 1.89 2.9 6.31 6.31 0 0 1 6.59 1c2.18 0 4 2.17 5.41 3.86C13.43 3.16 15.23 1 17.41 1z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-info\" viewBox=\"0 0 24 24\"><path d=\"M12 .25A11.75 11.75 0 1 0 23.75 12 11.76 11.76 0 0 0 12 .25zm0 21.15a9.4 9.4 0 1 1 9.4-9.4 9.41 9.41 0 0 1-9.4 9.4z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M13.18 15.53v-4.7A1.17 1.17 0 0 0 12 9.65H9.65V12h1.17v3.53H8.48v2.35h7.05v-2.35z\"/><circle cx=\"12\" cy=\"7.3\" r=\"1.47\"/></symbol>"

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-logout\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M18.23 10.87H5.77v2.26h12.46v3.4L23.89 12l-5.66-4.53zm-3.4 4.53h-2.26v4.53H2.37V4.07h10.2V8.6h2.26V1.81H.11v20.38h14.72z\"/></symbol>"

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-moderate\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0V0z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z\"/></symbol>"

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-more-h\" viewBox=\"0 0 24 24\"><path d=\"M14.59 12A2.59 2.59 0 1 1 12 9.41 2.59 2.59 0 0 1 14.59 12zm9.07 0a2.59 2.59 0 1 1-2.59-2.59 2.59 2.59 0 0 1 2.6 2.59zM5.52 12a2.59 2.59 0 1 1-2.59-2.59A2.59 2.59 0 0 1 5.52 12z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-next-arrow\" viewBox=\"0 0 24 24\"><path d=\"M18.25 10.53L9.89 2.11 12 0l12 12-12 12-2.11-2.11 8.36-8.42H0v-2.94h18.25z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-options-collapse\" viewBox=\"0 0 24 24\"><path d=\"M5.47 0L3.69 1.66 12 9.5l8.31-7.84L18.53 0 12 6.17 5.47 0zM12 17.82L18.53 24l1.78-1.66L12 14.5l-8.31 7.84L5.47 24 12 17.82z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-options-expand\" viewBox=\"0 0 24 24\"><path d=\"M12 3.33l6.53 6.17 1.78-1.66L12 0 3.69 7.84 5.47 9.5 12 3.33zM5.47 14.5l-1.78 1.66L12 24l8.31-7.84-1.78-1.66L12 20.68 5.47 14.5z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-photo\" viewBox=\"0 0 24 24\"><path d=\"M23.07 4.54a2.2 2.2 0 0 0-1.63-.71h-3.75l-2.16-2.28H8.47L6.31 3.83H2.56a2.2 2.2 0 0 0-1.63.71 2.27 2.27 0 0 0-.69 1.64v13.93a2.27 2.27 0 0 0 .69 1.63 2.2 2.2 0 0 0 1.63.71h18.88a2.2 2.2 0 0 0 1.63-.71 2.27 2.27 0 0 0 .69-1.63V6.18a2.27 2.27 0 0 0-.69-1.64zm-1.27 14a1.82 1.82 0 0 1-.57 1.33 1.86 1.86 0 0 1-1.36.57H4.13a1.86 1.86 0 0 1-1.36-.57 1.82 1.82 0 0 1-.57-1.33v-11a1.82 1.82 0 0 1 .57-1.33 1.86 1.86 0 0 1 1.36-.57h3.13l1.8-2.13h5.89l1.79 2.13h3.13a1.86 1.86 0 0 1 1.36.57 1.82 1.82 0 0 1 .57 1.33z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M16.17 8.51A5.69 5.69 0 0 0 12 6.77a5.69 5.69 0 0 0-4.17 1.74 5.69 5.69 0 0 0-1.74 4.17 5.69 5.69 0 0 0 1.74 4.17A5.69 5.69 0 0 0 12 18.59a5.69 5.69 0 0 0 4.17-1.74 5.69 5.69 0 0 0 1.74-4.17 5.69 5.69 0 0 0-1.74-4.17zm-1.52 6.79a3.73 3.73 0 0 1-5.3 0 3.73 3.73 0 0 1 0-5.3 3.73 3.73 0 0 1 5.3 0 3.73 3.73 0 0 1 0 5.3z\"/></symbol>"

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-posts\" viewBox=\"0 0 24 24\"><path d=\"M10.71 3H3v18h18v-7.7H10.71zm2.58 1.8v5.9h5.9zm9.63 7.2h.66v9A2.67 2.67 0 0 1 21 23.58H3a2.46 2.46 0 0 1-1.84-.78A2.54 2.54 0 0 1 .42 21V3a2.54 2.54 0 0 1 .75-1.8A2.46 2.46 0 0 1 3 .42h9v.66l.6-.6L23.52 11.4z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-profile\" viewBox=\"0 0 24 24\"><path d=\"M15.87 13.86l1 .21a14.51 14.51 0 0 1 4.8 2.07c1.45 1 2.18 2.05 2.18 3.25v4.42H.18v-4.42c0-1.2.73-2.28 2.18-3.25a14.51 14.51 0 0 1 4.8-2.07l1-.21a7.8 7.8 0 0 1-1.36-1.07 7 7 0 0 1-2.17-5.17A7.18 7.18 0 0 1 6.8 2.4 7.06 7.06 0 0 1 12 .2a7.06 7.06 0 0 1 5.2 2.2 7.18 7.18 0 0 1 2.17 5.22 7 7 0 0 1-2.17 5.17 7.8 7.8 0 0 1-1.33 1.07zM12 16.28a16.64 16.64 0 0 0-6 1.14c-2 .76-3 1.42-3 2V21h18v-1.61c0-.55-1-1.21-3-2a16.64 16.64 0 0 0-6-1.11zM11.84 3a4.25 4.25 0 0 0-3.15 1.31 4.34 4.34 0 0 0-1.27 3.18 4.18 4.18 0 0 0 1.27 3.13 4.33 4.33 0 0 0 3.15 1.24A4.32 4.32 0 0 0 15 10.62a4.19 4.19 0 0 0 1.28-3.13A4.35 4.35 0 0 0 15 4.31 4.25 4.25 0 0 0 11.84 3z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-question\" viewBox=\"0 0 24 24\"><path d=\"M12 4.89a4.55 4.55 0 0 1 3.33 1.39 4.55 4.55 0 0 1 1.39 3.33 4.35 4.35 0 0 1-1.78 3.08q-1.78 1.58-1.78 2.86h-2.33a4.16 4.16 0 0 1 .56-2.2A3.93 3.93 0 0 1 12.61 12a5.82 5.82 0 0 0 1.22-1 2 2 0 0 0 .56-1.39A2.2 2.2 0 0 0 13.67 8a2.35 2.35 0 0 0-3.32 0 2.2 2.2 0 0 0-.72 1.64H7.28a4.55 4.55 0 0 1 1.39-3.36A4.55 4.55 0 0 1 12 4.89z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M20.36 3.63A11.4 11.4 0 0 0 12 .16a11.4 11.4 0 0 0-8.36 3.48A11.4 11.4 0 0 0 .16 12a11.4 11.4 0 0 0 3.48 8.37A11.4 11.4 0 0 0 12 23.84a11.4 11.4 0 0 0 8.37-3.48A11.4 11.4 0 0 0 23.84 12a11.4 11.4 0 0 0-3.48-8.37zM18.7 18.69A9.14 9.14 0 0 1 12 21.5a9.14 9.14 0 0 1-6.7-2.8A9.14 9.14 0 0 1 2.5 12a9.14 9.14 0 0 1 2.8-6.7A9.14 9.14 0 0 1 12 2.5a9.14 9.14 0 0 1 6.7 2.8 9.14 9.14 0 0 1 2.8 6.7 9.14 9.14 0 0 1-2.8 6.69z\"/><path d=\"M10.83 19.16v-2.44h2.33v2.39l-2.33.05z\"/></symbol>"

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-quote\" viewBox=\"0 0 24 24\"><path d=\"M.28 14.81c0 4.11 2.65 6.44 5.62 6.44a5 5 0 0 0 5-5 4.29 4.29 0 0 0-4.3-4.54 3.11 3.11 0 0 0-1.26.19 11 11 0 0 1 4.93-6L6.79 3.13A14.36 14.36 0 0 0 .28 14.81zm12.88 0c0 4.11 2.59 6.44 5.56 6.44a5 5 0 0 0 5-5 4.27 4.27 0 0 0-4.23-4.55 3.11 3.11 0 0 0-1.26.19c.51-2.27 2.91-4.93 4.93-6l-3.55-2.76a14.3 14.3 0 0 0-6.44 11.68z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-reply\" viewBox=\"0 0 24 24\"><path d=\"M5.43 10.21l4.28-4.56-1.82-2L.5 11.57l7.39 7.9 1.82-2-4.35-4.6a29.76 29.76 0 0 1 10.46 1.71 19.12 19.12 0 0 1 7.68 5.75c-.66-3.33-3.09-5.75-6.13-7.46-2.68-1.51-7.07-2.51-11.94-2.66z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-search\" viewBox=\"0 0 24 24\"><path d=\"M21.707 20.293L16.314 14.9A7.928 7.928 0 0 0 18 10a7.945 7.945 0 0 0-2.344-5.656A7.94 7.94 0 0 0 10 2a7.94 7.94 0 0 0-5.656 2.344A7.945 7.945 0 0 0 2 10c0 2.137.833 4.146 2.344 5.656A7.94 7.94 0 0 0 10 18a7.922 7.922 0 0 0 4.9-1.686l5.393 5.392 1.414-1.413zM10 16a5.959 5.959 0 0 1-4.242-1.757A5.958 5.958 0 0 1 4 10c0-1.602.624-3.109 1.758-4.242A5.956 5.956 0 0 1 10 4c1.603 0 3.109.624 4.242 1.758A5.957 5.957 0 0 1 16 10c0 1.603-.624 3.11-1.758 4.243A5.959 5.959 0 0 1 10 16z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-settings\" viewBox=\"0 0 24 24\"><path d=\"M23.75 14v-4h-2.16a9.65 9.65 0 0 0-1.43-3.43l1.53-1.54-2.76-2.73-1.54 1.54A9.65 9.65 0 0 0 14 2.41V.25h-4v2.16a9.73 9.73 0 0 0-3.39 1.43L5.08 2.31 2.31 5.08l1.53 1.53A9.65 9.65 0 0 0 2.41 10H.25v4h2.16a9.49 9.49 0 0 0 1.44 3.43l-1.54 1.5 2.77 2.76 1.53-1.53a9.7 9.7 0 0 0 3.44 1.43v2.16H14v-2.16a9.76 9.76 0 0 0 3.43-1.43l1.54 1.53 2.76-2.77-1.53-1.53A9.73 9.73 0 0 0 21.59 14zM12 18.53A6.53 6.53 0 1 1 18.53 12 6.53 6.53 0 0 1 12 18.53z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-social-facebook\" viewBox=\"0 0 24 24\"><path d=\"M13.84 23.86V13h3.63L18 8.82h-4.16V6.13c0-1.22.34-2.05 2.09-2.05h2.23V.31A29.87 29.87 0 0 0 14.9.14c-3.22 0-5.42 2-5.42 5.57v3.11H5.84V13h3.64v10.86z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-social-google\" viewBox=\"0 0 24 24\"><path d=\"M.47 11.41A11.77 11.77 0 0 1 12.23.21a12 12 0 0 1 7.88 2.91 42 42 0 0 1-3 3.1C14.44 4.37 10.63 3.84 7.95 6a7.55 7.55 0 0 0-.32 11.77C11.21 21 18 19.39 19 14.41c-2.25 0-4.5 0-6.75-.07v-4h11.27c.23 3.15-.19 6.51-2.13 9.12C18.44 23.57 12.55 24.77 8 23A11.8 11.8 0 0 1 .47 11.41z\" fill=\"#fff\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-social-pinterest\" viewBox=\"0 0 24 24\"><path d=\"M7.07 21a14 14 0 0 1 0-3.68c.22-1 1.52-6.5 1.52-6.5a6.15 6.15 0 0 1-.32-1.95C8.27 7 9.35 5.7 10.65 5.7a1.65 1.65 0 0 1 1.62 1.84c0 1.08-.76 2.81-1.08 4.33a1.91 1.91 0 0 0 1.95 2.38c2.27 0 4.11-2.38 4.11-6A5.14 5.14 0 0 0 11.84 3 5.64 5.64 0 0 0 6 8.62a5 5 0 0 0 1 2.92.4.4 0 0 1 .11.32 13.08 13.08 0 0 0-.32 1.52c-.11.22-.22.32-.43.22-1.62-.76-2.6-3.14-2.6-5 0-4.11 3-7.9 8.55-7.9 4.55 0 8 3.25 8 7.47 0 4.44-2.81 8.12-6.71 8.12a3.49 3.49 0 0 1-3-1.52s-.65 2.49-.76 3.14a39.63 39.63 0 0 1-2.45 5.3c1.02.35-.14-.87-.32-2.21z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-social-twitter\" viewBox=\"0 0 24 24\"><path d=\"M20.87 5.58A4.56 4.56 0 0 0 22.93 3a11.17 11.17 0 0 1-3 1.11 4.49 4.49 0 0 0-3.45-1.51 4.66 4.66 0 0 0-3.4 1.4 4.58 4.58 0 0 0-1.38 3.34 3.35 3.35 0 0 0 .15 1.05A12.74 12.74 0 0 1 2 3.46a4.76 4.76 0 0 0-.66 2.38 4.59 4.59 0 0 0 2.12 4 5.26 5.26 0 0 1-2.12-.6 4.72 4.72 0 0 0 1.06 3.07 4.66 4.66 0 0 0 2.72 1.66 5.07 5.07 0 0 1-1.26.15A2.36 2.36 0 0 1 3 14a4.55 4.55 0 0 0 1.7 2.36 4.7 4.7 0 0 0 2.77 1 9.27 9.27 0 0 1-5.89 2 8 8 0 0 1-1.16 0 13.11 13.11 0 0 0 7.3 2.04A13 13 0 0 0 15 19.3a13.1 13.1 0 0 0 4.68-5.11 13.86 13.86 0 0 0 1.51-6.3v-.6a10 10 0 0 0 2.37-2.47 10.48 10.48 0 0 1-2.69.76z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-sort\" viewBox=\"0 0 24 24\"><path d=\"M4.12 10.63h15.77v2.74H4.12zM.09 4.04h23.82v2.74H.09zM9.15 17.21h5.71v2.74H9.15z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-star--empty\" viewBox=\"0 0 24 24\"><path d=\"M12 18l-6.4 3.88 1.73-7.33-5.66-4.93L9.09 9 12 2.09 14.91 9l7.42.64-5.63 5 1.72 7.34z\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-star--full\" viewBox=\"0 0 24 24\"><path d=\"M12 18.66l-7.44 4.35 1.98-8.16L0 9.36l8.62-.7L12 .99l3.38 7.67 8.62.7-6.54 5.49 1.98 8.16L12 18.66z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-star--half\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M12 2.09L9.09 9l-7.42.62 5.66 4.93-1.72 7.32 1.07-.65L12 17.97V2.09z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M12 2.09L14.91 9l7.42.62-5.66 4.93 1.72 7.32-1.07-.65L12 17.97V2.09z\"/></symbol>"

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-unhelpful-off\" viewBox=\"0 0 24 24\"><path d=\"M12 4.2l-.11.11c-1.81 1.61-3.14 2.84-4 3.69s-1.81 1.77-2.82 2.9a12.41 12.41 0 0 0-2.11 3 6 6 0 0 0-.59 2.53 4 4 0 0 0 1.21 3 4.12 4.12 0 0 0 3 1.18 4.68 4.68 0 0 0 2.62-.79 4 4 0 0 0 1.66-2h2.26a4 4 0 0 0 1.66 2 4.68 4.68 0 0 0 2.62.79 4.12 4.12 0 0 0 3-1.18 4 4 0 0 0 1.21-3 6 6 0 0 0-.61-2.54 12.41 12.41 0 0 0-2.11-3C17.92 9.77 17 8.8 16.11 8s-2.19-2-4-3.66zm0 16.28A6.78 6.78 0 0 1 6.59 23a6.31 6.31 0 0 1-4.7-1.91A6.42 6.42 0 0 1 0 16.42a8.75 8.75 0 0 1 1.46-4.56 23.08 23.08 0 0 1 3.19-4.11c1.14-1.17 3-2.91 5.6-5.24L12 1l1.75 1.57q3 2.72 4.33 4c.91.87 1.91 1.94 3 3.21a12.77 12.77 0 0 1 2.28 3.47 8.53 8.53 0 0 1 .64 3.17 6.42 6.42 0 0 1-1.89 4.68 6.31 6.31 0 0 1-4.7 1.9A6.78 6.78 0 0 1 12 20.48z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-unhelpful-on\" viewBox=\"0 0 24 24\"><path d=\"M12 19.15C10.57 20.84 8.77 23 6.59 23a6.31 6.31 0 0 1-4.7-1.91A6.42 6.42 0 0 1 0 16.42a8.75 8.75 0 0 1 1.46-4.56 23.08 23.08 0 0 1 3.19-4.11c1.14-1.17 3-2.91 5.6-5.24L12 1l1.75 1.57q3 2.72 4.33 4c.91.87 1.91 1.94 3 3.21a12.77 12.77 0 0 1 2.28 3.47 8.53 8.53 0 0 1 .64 3.17 6.42 6.42 0 0 1-1.89 4.68 6.31 6.31 0 0 1-4.7 1.9c-2.18 0-3.98-2.16-5.41-3.85z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-video\" viewBox=\"0 0 24 24\"><path d=\"M23.1 3.28a2.18 2.18 0 0 0-1.63-.72H2.53a2.18 2.18 0 0 0-1.63.72 2.29 2.29 0 0 0-.7 1.66v14.12a2.29 2.29 0 0 0 .7 1.66 2.18 2.18 0 0 0 1.63.72h18.94a2.18 2.18 0 0 0 1.63-.72 2.29 2.29 0 0 0 .7-1.66V4.94a2.29 2.29 0 0 0-.7-1.66zM8.46 16.93V7.4l9.44 4.81z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-vote-off\" viewBox=\"0 0 24 24\"><path d=\"M13.71 4.32c2.92 4.52 10 14 10 14a2.34 2.34 0 0 1-2.33 2.33H2.62a2.34 2.34 0 0 1-2.33-2.36s6.81-9.48 10.29-14a1.8 1.8 0 0 1 3.13.03zm-11.08 14h18.74L12 6.64z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-vote-on\" viewBox=\"0 0 24 24\"><path d=\"M13.71 4.32c2.92 4.52 10 14 10 14a2.35 2.35 0 0 1-2.33 2.33H2.62A2.34 2.34 0 0 1 .29 18.3s6.81-9.48 10.29-14A1.8 1.8 0 0 1 13 3.64a1.82 1.82 0 0 1 .71.68z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-write\" viewBox=\"0 0 24 24\"><path d=\"M22.39 1.61a4.74 4.74 0 0 0-6.71 0L2.24 15a1.5 1.5 0 0 0-.31.54L.25 22.32a1.18 1.18 0 0 0 .31 1.12 1.18 1.18 0 0 0 1.12.31l6.72-1.68a1.49 1.49 0 0 0 .54-.31H9L22.39 8.32a4.75 4.75 0 0 0 0-6.71zm-7.55 4.18l3.37 3.37-10.09 10.1-3.37-3.38zM3 21l.7-2.8 2.1 2.1zM20.73 3.27a2.45 2.45 0 0 1 0 3.37l-.85.85-3.37-3.37.85-.85a2.44 2.44 0 0 1 3.37 0z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ })
],[148]);


// WEBPACK FOOTER //
// VuTUYdwvqIExdDFsite/js/non-defined-page.js